/*
Libraries aready present that can use used
- jQuery
- slick
- swiper
- photoswipe

Notes:
1. the `floraqueen` It is a special object that has been created where all the information like locations, prices, special notes will be stored.
*/

window.floraqueen = window.floraqueen || {};

var domain = window.location.hostname;
const domainTlds = domain.substring(domain.lastIndexOf('.') + 1);
  console.log('domain', domain);
  window.current_domain = null;
  window.domainMargin = {'domain': null, 'amount': null, 'decimalRounding': null};
  if(window?.domainMargins){ //meta fields data from theme.liquid
    const domainDetails = window?.domainMargins?.find(entry => domain.includes(entry.domain));
    console.log('domainDetails margin:', domainDetails);
    window.domainMargin = {'domain': domainDetails?.domain, 'amount': domainDetails?.amount, 'decimalRounding': domainDetails?.rounding};
  }
// if (domain.includes('.com.co') || domain.includes('.com')) {
//     window.current_domain = '.com';
//     console.log('current_domain', window.current_domain);
// } else{
//     window.current_domain = 'other';
// }

// ============================================
// PHASE 1 - STEP 1: Default delivery country by domain + collection pricing
// ============================================
function isPlainComDomain(hostname) {
  const host = (hostname || '').toLowerCase();
  return host.includes('.com') &&
    !host.includes('.com.') &&
    !host.includes('.com.co') &&
    !host.includes('.com.br') &&
    !host.includes('.com.tr') &&
    !host.includes('.com.ru');
}

function getDomainMarketDefaults(hostname) {
  const host = (hostname || window.location.hostname || '').toLowerCase();
  const presets = [
    { test: function () { return host.endsWith('.com.ru'); }, currency: 'EUR', country: 'Russia', countryCode: 'RU' },
    { test: function () { return host.endsWith('.com.tr'); }, currency: 'EUR', country: 'Turkey', countryCode: 'TR' },
    { test: function () { return host.endsWith('.com.br'); }, currency: 'EUR', country: 'Brazil', countryCode: 'BR' },
    { test: function () { return host.endsWith('.de'); }, currency: 'EUR', country: 'Germany', countryCode: 'DE' },
    { test: function () { return host.endsWith('.pl'); }, currency: 'EUR', country: 'Poland', countryCode: 'PL' },
    { test: function () { return host.endsWith('.it'); }, currency: 'EUR', country: 'Italy', countryCode: 'IT' },
    { test: function () { return host.endsWith('.es'); }, currency: 'EUR', country: 'Spain', countryCode: 'ES' },
    { test: function () { return host.endsWith('.fr'); }, currency: 'EUR', country: 'France', countryCode: 'FR' },
    { test: function () { return isPlainComDomain(host); }, currency: 'EUR', country: 'Germany', countryCode: 'DE' }
  ];

  for (let i = 0; i < presets.length; i++) {
    if (presets[i].test()) {
      return {
        currency: presets[i].currency,
        country: presets[i].country,
        countryCode: presets[i].countryCode
      };
    }
  }
  return null;
}

(function(){
  'use strict';
  const domain = window.location.hostname;
  window.isComDomain = isPlainComDomain(domain);
  const domainDefaults = getDomainMarketDefaults(domain);
  window.domainMarketDefaults = domainDefaults;
  window.usesDomainPricing = window.isComDomain;

  if (domainDefaults) {
    const storedCurrency = localStorage.getItem('floraqueen_user_currency');
    const storedCountry = localStorage.getItem('floraqueen_deliveryCountry');
    const storedCountryCode = localStorage.getItem('floraqueen_deliveryCountryCode');
    const hasStoredPreferences = storedCurrency && storedCountry && storedCountryCode;
    if (!hasStoredPreferences) {
      console.log('🌍 First-time visitor - no localStorage:', domainDefaults);
      localStorage.setItem('floraqueen_user_currency', domainDefaults.currency);
      localStorage.setItem('floraqueen_deliveryCountry', domainDefaults.country);
      localStorage.setItem('floraqueen_deliveryCountryCode', domainDefaults.countryCode);
    } else {
      console.log('✅ Using stored preferences:', {
        currency: storedCurrency.trim(),
        country: storedCountry.trim(),
        countryCode: storedCountryCode.trim()
      });
    }
  }
})();

// Auto-select Premium/Deluxe variant after DOM is ready
$(document).ready(function() {
  // Initialize dynamic pricing for .com only
  if (window.usesDomainPricing) {
    // Immediately hide prices and kick off pricing initialization to avoid EUR flash
    hideAllPrices();
    window.fqPricingInitPromise = initializePricingForPage().finally(function() {
      window.fqPricingInitComplete = true;
    });
  }
  
  // Function to update prices after filter/sort changes
  function updatePricesAfterFilterChange() {
    if (!window.usesDomainPricing) return;
    if (!window.fqPricingInitComplete) return;
    
    console.log('🔍 Filter/sort change detected - updating prices...');
    
    // Get country code with proper precedence (collection metafield > localStorage > default)
    const countryInfo = getCountryCodeForPricing();
    const countryCode = countryInfo.countryCode;
    
    // Hide prices before update
    hideAllPrices();
    
    // Small delay to ensure new products are rendered
    setTimeout(function() {
      updateCollectionPagePrices(countryCode).then(function() {
        console.log('✅ Prices updated after filter/sort change');
      }).catch(function(error) {
        console.error('❌ Error updating prices after filter/sort:', error);
      });
    }, 300); // Delay to ensure DOM is updated
  }
  
  // Listen for filter changes event
  document.addEventListener('filters-applied', updatePricesAfterFilterChange);
  
  // Also listen for URL changes (in case filters cause page reload or history change)
  let lastUrl = window.location.href;
  window.addEventListener('popstate', function() {
    if (window.location.href !== lastUrl) {
      lastUrl = window.location.href;
      // Check if we're on a collection page
      if (window.location.pathname.includes('/collections/')) {
        updatePricesAfterFilterChange();
      }
    }
  });
  
  // Watch for new products added to DOM (backup method)
  if (window.usesDomainPricing && window.MutationObserver) {
    const priceUpdateObserver = new MutationObserver(function(mutations) {
      let shouldUpdate = false;
      
      mutations.forEach(function(mutation) {
        // Check if new product cards were added
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // Check if it's a product card or contains product cards
              if (node.classList && (
                node.classList.contains('cpb-price') ||
                node.classList.contains('cpb-cont') ||
                node.querySelector && node.querySelector('.cpb-price[data-product-id]')
              )) {
                shouldUpdate = true;
              }
            }
          });
        }
      });
      
      // Debounce updates
      if (shouldUpdate) {
        clearTimeout(window.priceUpdateTimeout);
        window.priceUpdateTimeout = setTimeout(function() {
          if (!window.fqPricingInitComplete) return;
          // Only update if we're on a collection page
          if (window.location.pathname.includes('/collections/')) {
            updatePricesAfterFilterChange();
          }
        }, 1000);
      }
    });
    
    // Observe the results container where products are rendered
    const resultsContainer = document.querySelector('.cc-filters-results, .row[data-section-type="collection"]');
    if (resultsContainer) {
      priceUpdateObserver.observe(resultsContainer, {
        childList: true,
        subtree: true
      });
    }
  }
});

// Define SheetJSON URLs
const priceModifierUrl = "https://sheetjson.com/spreadsheets/d/12-aI_r6LIb6dAwvoNUkMAJJ6f3sffxNQElkiOUnTu1I/edit?gid=198474917#gid=198474917";
const countryCodesUrl = "https://sheetjson.com/spreadsheets/d/12-aI_r6LIb6dAwvoNUkMAJJ6f3sffxNQElkiOUnTu1I/edit?gid=1726063397#gid=1726063397";

// LocalStorage keys
const STORAGE_KEYS = {
  FULL_ADDRESS: 'floraqueen_fullDeliveryAddress',
  COUNTRY: 'floraqueen_deliveryCountry',
  COUNTRY_CODE: 'floraqueen_deliveryCountryCode',
  // Separate storage for city-based addresses (from URL parameter)
  CITY_FULL_ADDRESS: 'floraqueen_cityFullDeliveryAddress',
  CITY_COUNTRY: 'floraqueen_cityDeliveryCountry',
  CITY_COUNTRY_CODE: 'floraqueen_cityDeliveryCountryCode'
};

// Default market settings
const DEFAULT_MARKET = 'DE'; // Germany as default
const DEFAULT_LANGUAGE = 'en'; // English as default language

// Check if wallart template
function checkIsWallartTemplate() {
  const productContainer = document.querySelector('.main-product-cont');
  if (!productContainer) return false;
  const template = (productContainer.dataset.template || '').toLowerCase();
  return template.includes('wallart-product');
}

// Allowed countries (metafield-driven with fallback)
// Using ISO country codes for reliable matching across locales
const FALLBACK_ALLOWED_COUNTRY_CODES_BASE = [
  "HR", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IT", "LV", "LT", "LU",
  "NL", "NO", "PL", "PT", "RO", "SK", "SI", "ES", "SE", "LI", "MD", "MK", "AL",
  "AD", "BA", "MC", "SM", "RS"
];

// Add US if wallart template
const isWallartTemplate = checkIsWallartTemplate();
const FALLBACK_ALLOWED_COUNTRY_CODES = isWallartTemplate
  ? [...FALLBACK_ALLOWED_COUNTRY_CODES_BASE, "US"]
  : FALLBACK_ALLOWED_COUNTRY_CODES_BASE;

// Country name to code mapping for fallback (English names)
const COUNTRY_NAME_TO_CODE_BASE = {
  "croatia": "HR", "czechia": "CZ", "czech republic": "CZ", "denmark": "DK",
  "estonia": "EE", "finland": "FI", "france": "FR", "germany": "DE",
  "greece": "GR", "hungary": "HU", "italy": "IT", "latvia": "LV",
  "lithuania": "LT", "luxembourg": "LU", "netherlands": "NL", "norway": "NO",
  "poland": "PL", "portugal": "PT", "romania": "RO", "slovakia": "SK",
  "slovenia": "SI", "spain": "ES", "sweden": "SE", "liechtenstein": "LI",
  "moldova": "MD", "north macedonia": "MK", "macedonia": "MK", "albania": "AL",
  "andorra": "AD", "bosnia & herzegovina": "BA", "bosnia and herzegovina": "BA",
  "monaco": "MC", "san marino": "SM", "serbia": "RS"
};

// Add US if wallart template
const COUNTRY_NAME_TO_CODE = isWallartTemplate
  ? { ...COUNTRY_NAME_TO_CODE_BASE, "United States": "US"}
  : COUNTRY_NAME_TO_CODE_BASE;

function normalizeCountryValue(value) {
  if (!value) return null;
  return String(value).trim().toLowerCase();
}

function buildAllowedCountrySets() {
  const codes = new Set();
  const names = new Set();
  const metafieldValue = window.shippingAllowedCountries;

  function processEntry(entry) {
    if (!entry) return;
    if (typeof entry === 'string') {
      const normalized = normalizeCountryValue(entry);
      // If it's a 2-letter uppercase code, treat as code
      if (normalized.length === 2 && normalized === entry.toUpperCase().toLowerCase()) {
        codes.add(normalized);
      } else {
        // Otherwise treat as name and try to map to code
        names.add(normalized);
        const mappedCode = COUNTRY_NAME_TO_CODE[normalized];
        if (mappedCode) codes.add(mappedCode.toLowerCase());
      }
    } else if (typeof entry === 'object') {
      if (entry.code) {
        const code = normalizeCountryValue(entry.code);
        codes.add(code);
      }
      if (entry.name) {
        const name = normalizeCountryValue(entry.name);
        names.add(name);
        const mappedCode = COUNTRY_NAME_TO_CODE[name];
        if (mappedCode) codes.add(mappedCode.toLowerCase());
      }
      if (Array.isArray(entry.values)) entry.values.forEach(processEntry);
    }
  }

  if (Array.isArray(metafieldValue)) {
    metafieldValue.forEach(processEntry);
  } else if (metafieldValue && typeof metafieldValue === 'object') {
    if (Array.isArray(metafieldValue.countries)) {
      metafieldValue.countries.forEach(processEntry);
    } else if (Array.isArray(metafieldValue.allowed)) {
      metafieldValue.allowed.forEach(processEntry);
    }
  }

  // Use fallback if no metafield data
  if (codes.size === 0 && names.size === 0) {
    FALLBACK_ALLOWED_COUNTRY_CODES.forEach(code => codes.add(code.toLowerCase()));
  }

  return { codes, names };
}

const { codes: allowedCountryCodes, names: allowedCountryNames } = buildAllowedCountrySets();

const NON_SHIP_MESSAGE_ID = 'fq-non-shipping-message';
const NON_SHIP_BUTTON_ID = 'fq-non-shipping-button';
function toggleNonShippingMessage(shouldShow, countryName) {
  const input = document.getElementById("productPageAddressInput");
  if (!input) return;

  let container = document.getElementById(NON_SHIP_MESSAGE_ID);
  if (!container) {
    container = document.createElement('div');
    container.id = NON_SHIP_MESSAGE_ID;
    container.style.color = '#c64e14';
    container.style.fontSize = '14px';
    container.style.marginTop = '8px';
    container.style.lineHeight = '1.4';
    container.style.marginBottom = '12px';
    const parent = input.parentNode;
    if (parent && parent.parentNode) {
      parent.parentNode.insertBefore(container, parent.nextSibling);
    } else {
      input.insertAdjacentElement('afterend', container);
    }
  }

  let buttonContainer = document.getElementById(NON_SHIP_BUTTON_ID);
  if (!buttonContainer) {
    buttonContainer = document.createElement('div');
    buttonContainer.id = NON_SHIP_BUTTON_ID;
    buttonContainer.style.marginTop = '12px';
    const parent = container.parentNode;
    if (parent) {
      parent.insertBefore(buttonContainer, container.nextSibling);
    } else {
      container.insertAdjacentElement('afterend', buttonContainer);
    }
  }

  if (shouldShow) {
    // Use new translated message if available, fallback to old message
    let messageText = window.shippingNotAvailableMessageNew || window.shippingNotAvailableMessage || 'We do not ship to .';
    
    // Ensure messageText is a string
    if (typeof messageText !== 'string') {
      messageText = String(messageText);
    }
    
    // Clean up any double spaces
    messageText = messageText.replace(/\s+/g, ' ').trim();
    
    container.innerHTML = messageText;
    container.style.display = 'block';

    // Create or update button
    let button = buttonContainer.querySelector('button');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.style.backgroundColor = '#ed600e';
      button.style.color = '#ffffff';
      button.style.border = 'none';
      button.style.padding = '12px 24px';
      button.style.fontSize = '14px';
      button.style.fontWeight = '600';
      button.style.cursor = 'pointer';
      button.style.borderRadius = '4px';
      button.style.textTransform = 'uppercase';
      button.style.transition = 'background-color 0.3s ease';
      button.addEventListener('mouseenter', function() {
        this.style.backgroundColor = '#a03d0f';
      });
      button.addEventListener('mouseleave', function() {
        this.style.backgroundColor = '#ed600e';
      });
      button.addEventListener('click', function() {
        // Get current locale root URL if available
        const currentLocale = window.Shopify?.locale || 'en';
        let localePrefix = '';
        if (currentLocale !== 'en' && window.Shopify?.routes?.root) {
          localePrefix = window.Shopify.routes.root.replace(/\/$/, '');
        }
        window.location.href = localePrefix + '/collections/flowers';
      });
      buttonContainer.appendChild(button);
    }
    
    // Update button text
    const buttonText = window.shippingDiscoverGiftsButton || 'DISCOVER THE GIFTS';
    button.textContent = buttonText;
    buttonContainer.style.display = 'block';
    
    // Hide the add to cart button(s) when message is shown
    const addToCartButtons = document.querySelectorAll('.custom-addToCart-btn-os');
    addToCartButtons.forEach(function(btn) {
      btn.style.display = 'none';
    });
  } else {
    container.style.display = 'none';
    buttonContainer.style.display = 'none';
    
    // Show the add to cart button(s) when message is hidden
    const addToCartButtons = document.querySelectorAll('.custom-addToCart-btn-os');
    addToCartButtons.forEach(function(btn) {
      btn.style.display = '';
    });
  }
}

function shouldApplyCountryRestriction() {
  // More robust template detection
  const productContainer = document.querySelector('.main-product-cont');
  if (!productContainer) return false;
  
  // Check data-template attribute
  const template = (productContainer.dataset.template || '').toLowerCase();
  const isGiftBasketTemplate = template.includes('basket');
  
  // Check for redesign template
  const isRedesignTemplate = template.includes('custom') || template.includes('redesign');
  
  // Check for wallart template
  const isWallartTemplate = template.includes('wallart');
  
  // Check for personalized gifts indicator
  const belongsToPersonalizedGifts = !!document.querySelector('.cpm-outer-cont.personalize_product');

  if (isGiftBasketTemplate) return true;
  if (isRedesignTemplate && belongsToPersonalizedGifts) return true;
  if (isWallartTemplate) return true;
  return false;
}

function isWallartProduct() {
  // Check if this is a wallart product
  const productContainer = document.querySelector('.main-product-cont');
  if (!productContainer) return false;
  
  const template = (productContainer.dataset.template || '').toLowerCase();
  return template.includes('wallart');
}
function isBasketProduct() {
  // Check if this is a basket product
  const productContainer = document.querySelector('.main-product-cont');
  if (!productContainer) return false;
  
  const template = (productContainer.dataset.template || '').toLowerCase();
  return template.includes('baskets');
}
function isFujifilmProduct() {
  // Check if this is a fujifilm product
  const productContainer = document.querySelector('.main-product-cont');
  if (!productContainer) return false;

  const template = (productContainer.dataset.template || '').toLowerCase();
  return template.includes('fujifilm_products');
}

// Auto-add companion free gifts when bouquets + Classic/Premium are added to cart.
// Companion variant IDs: Sandy (50668515295560), I Love You (50434757493064)
var BOUQUET_CLASSIC_PREMIUM_COMPANION_IDS = [50668515295560, 50434757493064];
var VASE_VARIANT_ID = 50668515295560;

function shouldPassAppliedPrice(variantId, addonType) {
  if (!window.isComDomain) return false;
  if (addonType === 'vase') return false;
  if (parseInt(variantId, 10) === VASE_VARIANT_ID) return false;
  return true;
}

var BOUQUET_PRODUCT_TYPES = [
  'bouquets',
  'çiçek buketleri',
  'buquês',
  'bukiety',
  'букеты'
];

function getAtcProductType($button) {
  var fromBtn = $button && ($button.data('product-type') || $button.attr('data-product-type'));
  if (fromBtn) return String(fromBtn).trim();
  var container = document.querySelector('.main-product-cont');
  if (container && container.dataset.productType) {
    return String(container.dataset.productType).trim();
  }
  var typeEl = document.querySelector('.product-type a, .product-type');
  if (typeEl) return (typeEl.textContent || '').trim();
  return '';
}

function getSelectedVariantLabel(fallbackLabel) {
  var checked = document.querySelector('.product-options .opt-btn:checked');
  if (checked) {
    var fromData = checked.getAttribute('data-name') || checked.value;
    if (fromData) return String(fromData).trim();
  }
  return String(fallbackLabel || '').trim();
}

function isBouquetProductType(productType) {
  var type = String(productType || '').trim().toLowerCase();
  return BOUQUET_PRODUCT_TYPES.indexOf(type) !== -1;
}

function normalizeAtcVariantLabel(variantLabel) {
  var label = String(variantLabel || '').trim().toLowerCase();
  // Strip diacritics so "Clásico" -> "clasico"
  try {
    label = label.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  } catch (e) {}
  return label;
}

function isClassicOrPremiumVariant(variantLabel) {
  var raw = String(variantLabel || '').trim().toLowerCase();
  var label = normalizeAtcVariantLabel(variantLabel);
  if (!label && !raw) return false;

  // Exclude Deluxe / Best Value - Deluxe / Mejor Valor - Deluxe / Делюкс
  if (
    label.indexOf('deluxe') !== -1
    || label.indexOf('de lujo') !== -1
    || raw.indexOf('делюкс') !== -1
    || raw.indexOf('luxo') !== -1
  ) {
    return false;
  }

  // Premium (EN/most markets) + Premia (PL) + Премиум (RU)
  if (
    label === 'premium' || label === 'premia'
    || label.indexOf('premium') === 0 || label.indexOf('premia') === 0
    || /(^|[^a-z])premium([^a-z]|$)/.test(label)
    || /(^|[^a-z])premia([^a-z]|$)/.test(label)
    || raw.indexOf('премиум') !== -1
  ) {
    return true;
  }

  // Classic + localized titles across 9 domains
  // EN Classic, ES Clásico, FR Classique, IT Classico, DE Klassisch,
  // PL Klasyczny, TR Klasik, PT Clássico, RU Классический
  var classicTokens = [
    'classic', 'clasico', 'classique', 'classico',
    'klassisch', 'klasik', 'klassiek', 'klasyczny'
  ];
  for (var i = 0; i < classicTokens.length; i++) {
    var token = classicTokens[i];
    if (label === token || label.indexOf(token) === 0) return true;
    var re = new RegExp('(^|[^a-z])' + token + '([^a-z]|$)');
    if (re.test(label)) return true;
  }
  if (raw.indexOf('классическ') !== -1 || raw.indexOf('классик') !== -1) {
    return true;
  }
  return false;
}

function isExpressDeliveryPdp($button) {
  if ($button && ($button.data('prod_template') === 'express-delivery' || $button.attr('data-prod_template') === 'express-delivery')) {
    return true;
  }
  var cont = document.querySelector('.main-product-cont');
  if (!cont) return false;
  if (cont.classList.contains('pdp-express-delivery')) return true;
  if ((cont.getAttribute('data-view-suffix') || '') === 'express-delivery') return true;
  return false;
}

function appendBouquetClassicPremiumCompanions(items, productType, variantLabel) {
  if (!Array.isArray(items)) return items;
  // Express Delivery: Card/Vase are explicit only — never auto-add Sandy / I Love You
  if (isExpressDeliveryPdp()) return items;
  if (!isBouquetProductType(productType)) return items;
  if (!isClassicOrPremiumVariant(variantLabel)) return items;

  BOUQUET_CLASSIC_PREMIUM_COMPANION_IDS.forEach(function (companionId) {
    var alreadyPresent = items.some(function (item) {
      return parseInt(item.id, 10) === companionId;
    });
    if (!alreadyPresent) {
      items.push({ id: companionId, quantity: 1, properties: {} });
    }
  });
  return items;
}


function evaluateCountryShipping(countryName, countryCode) {
  if (!shouldApplyCountryRestriction()) {
    toggleNonShippingMessage(false);
    return true;
  }

  // Prioritize country code matching (more reliable across locales)
  const normalizedCode = countryCode ? normalizeCountryValue(countryCode) : null;
  const normalizedName = countryName ? normalizeCountryValue(countryName) : null;
  
  // Check if country code is allowed
  let isAllowed = false;
  if (normalizedCode) {
    isAllowed = allowedCountryCodes.has(normalizedCode);
  }
  
  // If code check didn't match, try name matching
  if (!isAllowed && normalizedName) {
    // Direct name match
    isAllowed = allowedCountryNames.has(normalizedName);
    
    // Try mapping name to code
    if (!isAllowed) {
      const mappedCode = COUNTRY_NAME_TO_CODE[normalizedName];
      if (mappedCode) {
        isAllowed = allowedCountryCodes.has(mappedCode);
      }
    }
  }

  // Use country name for display, fallback to code
  const displayName = countryName || countryCode || 'this country';
  toggleNonShippingMessage(!isAllowed, displayName);
  return isAllowed;
}

// Get User Country
(async () => {
  const res = await fetch(
    window.Shopify.routes.root +
      'browsing_context_suggestions.json' +
      `?country[enabled]=true` +
      `&country[exclude]=${window.Shopify.country}` +
      '&language[enabled]=true' +
      `&language[exclude]=${window.Shopify.language}`
  );
  const data = await res.json();
  window.floraqueen.user_country = data.detected_values;
})();

// Function to fetch data from SheetJSON
async function fetchSheetData(url) {
  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Failed to fetch data: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`Error fetching data from ${url}:`, error);
    return null;
  }
}
function calculatePrice(price, multiplier, roundingValue) {
  if (typeof price !== 'number' || typeof multiplier !== 'number') {
    console.error('calculatePrice: price and multiplier must be numbers');
    return price;
  }
  // For Fujifilm products, skip multiplier markup (e.g. 1.2) and only apply rounding
  if (typeof isFujifilmProduct === 'function' && isFujifilmProduct()) {
    multiplier = 1;
  }
  let calculatedPrice = price * multiplier;

  // If no roundingValue → return raw calculated price
  if (roundingValue == null || typeof roundingValue !== 'number') {
    return calculatedPrice;
  }

  // Extract integer + decimal
  const integerPart = Math.floor(calculatedPrice);
  const decimalPart = +(calculatedPrice - integerPart).toFixed(2);

  // Apply your specific rounding rule:
  //
  // 1) If decimal < roundingValue → round to integer + roundingValue
  // 2) If decimal > roundingValue → round to next integer + roundingValue
  // 3) If decimal == roundingValue → keep as is
  //
  if (decimalPart < roundingValue) {
    calculatedPrice = integerPart + roundingValue;
  } else if (decimalPart > roundingValue) {
    calculatedPrice = integerPart + 1 + roundingValue;
  }
  return +calculatedPrice.toFixed(2);
}

// Apply domain margin markup to prices on variant change
// Use setTimeout to ensure this runs after the default updateProductPrices function
$(document).on('variantPriceChange', function(evt) {
  if (!window.isComDomain) return;

  setTimeout(function() {
    const variant = evt.variant;
    const $priceWrapper = $('[data-price-wrapper]');
    
    if ($priceWrapper.length === 0) return;
    
    // Get domain margin and rounding from data attributes
    const domainMargin = parseFloat($priceWrapper.data('domain-margin')) || 1;
    const domainRounding = $priceWrapper.data('domain-rounding');
    const roundingValue = domainRounding != null && domainRounding !== '' ? parseFloat(domainRounding) : null;
    
    // Only apply markup if domain margin is not 1 (meaning markup should be applied)
    if (domainMargin === 1 && roundingValue == null) return;
    
    // Calculate adjusted prices
    const variantPrice = variant.price / 100; // Convert from cents to dollars
    const adjustedPrice = calculatePrice(variantPrice, domainMargin, roundingValue);
    
    // Update price display
    const $price = $priceWrapper.find('[data-product-price]');
    if ($price.length) {
      const formattedPrice = theme.Shopify.formatMoney(adjustedPrice * 100, theme.moneyFormatWithCodePreference);
      $price.html('<span class="theme-money">' + formattedPrice + '</span>');
    }
    
    // Update compare price if exists
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const comparePrice = variant.compare_at_price / 100; // Convert from cents to dollars
      const adjustedComparePrice = calculatePrice(comparePrice, domainMargin, roundingValue);
      
      const $comparePrice = $priceWrapper.find('[data-compare-price]');
      if ($comparePrice.length) {
        const formattedComparePrice = theme.Shopify.formatMoney(adjustedComparePrice * 100, theme.moneyFormatWithCodePreference);
        $comparePrice.html('<span class="theme-money">' + formattedComparePrice + '</span>');
        $comparePrice.removeClass('hide');
        $price.addClass('product-price__reduced');
      }
    } else {
      const $comparePrice = $priceWrapper.find('[data-compare-price]');
      if ($comparePrice.length) {
        $comparePrice.addClass('hide');
        $price.removeClass('product-price__reduced');
      }
    }
  }, 10); // Small delay to ensure default price update runs first
});

// Check if a country code is available in the localization array
function isCountryInLocalization(countryCode) {
  if (!countryCode) return false;

  // Ensure localization exists
  if (!window.floraqueen.localization || !Array.isArray(window.floraqueen.localization)) {
    console.log("Localization array not available");
    return false;
  }

  // Check if country code is in the array (case insensitive)
  const found = window.floraqueen.localization.some(code =>
    code.toLowerCase() === countryCode.toLowerCase()
  );

  console.log(`Country check: ${countryCode} in localization: ${found}`);
  return found;
}
// Function to get ISO country code from country name
function getCountryCode(countryName) {
  if (!window.floraqueen.countryCodes || !countryName) return null;

  // Normalize the input country name for more reliable matching
  const normalize = (str) => str.toLowerCase().replace(/[^a-z]/g, '');

  const normalizedInput = normalize(countryName);

  // Find a match in the country codes data
  const countryData = window.floraqueen.countryCodes.find(item => {
    // Also normalize the country name from the spreadsheet data
    const normalizedSheetCountry = normalize(item["Country Name"]);
    return normalizedSheetCountry === normalizedInput;
  });

  if (countryData) {
    return countryData["Country Code"];
  }

  console.warn("Could not find a matching country code for:", countryName);
  return null;
}

// --- THEME PATCH ---
// This dummy function is placed in the global scope to prevent a ReferenceError
// from the theme's own scripts, which may fire when the DOM is changed.
window.updateActiveIndicator = function() {
  console.log("Theme patch: Dummy 'updateActiveIndicator' function called.");
};


function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
}

function getCookie(name) {
    const value = document.cookie.split('; ').find(row => row.startsWith(`${encodeURIComponent(name)}=`));
    return value ? decodeURIComponent(value.split('=')[1]) : null;
}

function deleteCookie(name) {
    document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}

/**
 * Rules for #del-date (see main-product-basket .basket-template-datepicker and other PDPs using #del-date).
 * - Sunday: disabled except March 8 and March 15.
 * - Basket template (including Sant Jordi basket): Saturday disabled — same as normal basket.
 */
function delDateBeforeShowDay(date, isBasketTemplate) {
  var day = date.getDay();
  var d = date.getDate();
  var m = date.getMonth();
  if (day === 0) {
    return [(m === 2 && (d === 8 || d === 15)), ''];
  }
  if (isBasketTemplate && day === 6) {
    return [false, ''];
  }
  return [true, ''];
}

/** First date on or after `date` that is allowed for basket template (weekend rules). */
function getFirstBasketSelectableOnOrAfter(date) {
  var cur = new Date(date);
  cur.setHours(0, 0, 0, 0);
  for (var i = 0; i < 14; i++) {
    if (delDateBeforeShowDay(cur, true)[0]) {
      return cur;
    }
    cur.setDate(cur.getDate() + 1);
  }
  return cur;
}

/**
 * Re-initializes the jQuery UI datepicker.
 */
function reinitializeDatePicker() {
  if (typeof jQuery == 'undefined' || typeof jQuery.ui == 'undefined') {
    console.error("jQuery or jQuery UI is not available to reinitialize the datepicker.");
    return;
  }

  const $input = $('#del-date');
  if (!$input.length) {
    console.log("Date picker input #del-date not found. Skipping reinitialization.");
    return;
  }

  if ($input.hasClass('hasDatepicker')) {
    $input.datepicker('destroy');
  }

  let $datepicker = null;

  function positionDatepicker($input, $picker) {
    if (!$input.length || !$picker) return;
    const inputOffset = $input.offset();
    const sddItem3Offset = $(".sdd-item-3").offset();
    if (!inputOffset || !sddItem3Offset) return;

    const inputHeight = $input.outerHeight();
    const pickerHeight = $picker.outerHeight();
    const pickerWidth = $picker.outerWidth();

    // Check if mobile device (screen width <= 767px)
    const isMobile = window.innerWidth <= 767;
    const scrollTop = $(window).scrollTop();
    
    const windowHeight = $(window).height();
    
    if (isMobile) {
      // Center the datepicker on mobile - position it in the center of the viewport
      const topPosition = Math.max(10, (windowHeight - pickerHeight) / 2);
      
      $picker.css({
        position: 'fixed',
        top: topPosition + 'px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 99999,
        margin: '0 auto'
      });
    } else {
      // Desktop positioning (original behavior - unchanged)
      $picker.css({
        position: 'absolute',
        top: inputOffset.top + (inputHeight / 2) - (pickerHeight / 2),
        left: sddItem3Offset.left - pickerWidth - 10,
        zIndex: 9999,
        transform: 'none',
        margin: '0'
      });
    }
  }
  
  // Check if input has both id="del-date" and class="basket-template-datepicker"
  const isBasketTemplate = $input.attr('id') === 'del-date' && $input.hasClass('basket-template-datepicker');
  let minDateValue;
  if (isBasketTemplate && typeof isBasketSantJordiProduct === 'function' && isBasketSantJordiProduct()) {
    minDateValue = typeof getSantJordiBasketChooseMinDate === 'function'
      ? getSantJordiBasketChooseMinDate()
      : new Date((typeof getSantJordiCampaignYear === 'function' ? getSantJordiCampaignYear() : new Date().getFullYear()), 3, 17);
  } else if (isBasketTemplate) {
    minDateValue = 6;
  } else {
    minDateValue = 0;
  }

  // Show 1 month on mobile, 2 months on desktop
  const isMobileDevice = window.innerWidth <= 767;
  const numberOfMonths = isMobileDevice ? 1 : 2;

  $input.datepicker({
    numberOfMonths: numberOfMonths,
    dateFormat: "dd MM yy",
    minDate: minDateValue,
    appendTo: "body",
    beforeShowDay: function(date) {
      return delDateBeforeShowDay(date, isBasketTemplate);
    },
    onSelect: function(dateText) {
      $(".main-product-cont[data-template='custom1'] .sdd-item-3 .sdd-day").text(dateText);
      $(".main-product-cont[data-template='custom1'] .sdd-item-3 .sdd-date").text('CHANGE');
      $(".main-product-cont[data-template='custom2'] .sdd-item-3 .sdd-price").text('CHANGE');
      $(".sdd-outer-item-3 .sdd-delivery-date").text(dateText);
    },
    beforeShow: function(input, inst) {
      setTimeout(function() {
        $datepicker = inst.dpDiv;
        // Small delay to ensure datepicker is fully rendered
        setTimeout(function() {
          positionDatepicker($(input), $datepicker);
        }, 10);
      }, 0);
    }
  });

  $(window).off('scroll.datepicker resize.datepicker').on('scroll.datepicker resize.datepicker', function() {
    if ($datepicker && $datepicker.is(':visible')) {
      positionDatepicker($input, $datepicker);
    }
  });

  console.log("Date picker reinitialized successfully.");
}

/**
 * Re-attaches all necessary event listeners to the product form.
 */
function reinitializeProductFormLogic() {
    console.log("Re-initializing all product form logic...");

    $(document).off('click', '.sdd-item').on('click', '.sdd-item', function(event) {
        const addon_wrapper = document.querySelector(".cpm-outer-cont");
        const atc_container = document.querySelector("#atc-form-container");
        if (atc_container) atc_container.style.display = "block";
        if (addon_wrapper) addon_wrapper.style.display = "block";
        $('.sdd-item').removeClass('sdd-active');
        $(this).addClass('sdd-active');
    });
    console.log("Re-attached delivery date listeners.");

    reinitializeDatePicker();

    setTimeout(() => {
        const premiumOption = $('[data-name="Premium"]');
        const deluxeOption = $('[data-name="Deluxe"]');

        if (premiumOption.length) {
            console.log("Auto-clicking 'Premium' variant to trigger date picker (after delay).");
            premiumOption[0].click();
        } else if (deluxeOption.length) {
            console.log("Auto-clicking 'Deluxe' variant to trigger date picker (after delay).");
            deluxeOption[0].click();
        }
        
        const deliveryDateContainer = document.querySelector(".sdd-outer-cont");
        // Hide delivery date section for wallart products
        if (deliveryDateContainer && !isWallartProduct()) {
            deliveryDateContainer.style.display = "block";
            console.log("Safeguard: Explicitly set .sdd-outer-cont display to block.");
            
            // Always run normal logic first
            // Then override for special countries and reinitialize datepicker
            setTimeout(function() {
              // This callback runs AFTER normal dates are set
              reinitializeDatePicker();
            }, 50);
        } else if (deliveryDateContainer && isWallartProduct()) {
            deliveryDateContainer.style.display = "none";
        }
    }, 100);
}
// Define the function before using it
async function fetchCurrencyExchangeRate(currencyCode) {
  try {
    const response = await fetch(`https://api.frankfurter.dev/v1/latest?base=${currencyCode}`);
    const data = await response.json();
    //console.log('Currency exchange rates:', data);
    return data.rates;
  } catch (error) {
    console.log('Error fetching currency exchange rate:', error);
    return null;
  }
}
/**
 * Get exchange rate for a specific currency (from EUR base)
 * @param {string} currencyCode - ISO currency code (e.g., 'USD', 'EUR', 'GBP')
 * @returns {Promise<number>} Exchange rate (1 for EUR, >1 for weaker currencies, <1 for stronger)
 */
async function getExchangeRate(currencyCode) {
  try {
    if (currencyCode === 'EUR' || !currencyCode) {
      return 1;
    }

    // Fetch exchange rate from API (base is EUR)
    const response = await fetch(`https://api.frankfurter.dev/v1/latest?base=EUR`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    const rate = data.rates[currencyCode];

    if (!rate) {
      console.warn(`Exchange rate not found for ${currencyCode}, defaulting to 1`);
      return 1;
    }

    return rate;
  } catch (error) {
    console.error('Error fetching exchange rate:', error);
    return 1; // Fallback to 1 if API fails
  }
}

/**
 * Calculate custom price with exchange rate and markup
 * Formula: (Base Price × Exchange Rate × margin), rounded to roundingValue
 */
function calculateCustomPrice(basePrice, exchangeRate = 1, roundingValue = 0.90, margin = 1.2) {
  if (typeof basePrice !== 'number' || basePrice <= 0) {
    console.error('calculateCustomPrice: basePrice must be a positive number, got:', basePrice);
    return basePrice;
  }

  if (typeof exchangeRate !== 'number' || exchangeRate <= 0) {
    console.warn('calculateCustomPrice: Invalid exchangeRate, using 1. Got:', exchangeRate);
    exchangeRate = 1;
  }

  if (typeof margin !== 'number' || margin <= 0) {
    console.warn('calculateCustomPrice: Invalid margin, using 1.2. Got:', margin);
    margin = 1.2;
  }

  // Apply formula: (Base Price × Exchange Rate × margin)
  const calculatedPrice = basePrice * exchangeRate * margin;

  // Round to roundingValue (e.g. .90)
  const integerPart = Math.floor(calculatedPrice);
  const decimalPart = calculatedPrice - integerPart;

  let finalPrice;
  if (decimalPart < roundingValue) {
    finalPrice = integerPart + roundingValue;
  } else if (decimalPart > roundingValue) {
    finalPrice = integerPart + 1 + roundingValue;
  } else {
    finalPrice = calculatedPrice;
  }

  return parseFloat(finalPrice.toFixed(2));
}

/**
 * Calculate custom price with automatic exchange rate fetching
 */
async function calculateCustomPriceWithCurrency(basePrice, currencyCode = 'USD', roundingValue = 0.90) {
  try {
    if (currencyCode === 'USD' || !currencyCode) {
      return calculateCustomPrice(basePrice, 1, roundingValue);
    }

    const rates = await fetchCurrencyExchangeRate('USD');

    if (!rates || !rates[currencyCode]) {
      console.warn(`Exchange rate not found for ${currencyCode}, using base price`);
      return calculateCustomPrice(basePrice, 1, roundingValue);
    }

    const exchangeRate = rates[currencyCode];
    return calculateCustomPrice(basePrice, exchangeRate, roundingValue);
  } catch (error) {
    console.error('Error in calculateCustomPriceWithCurrency:', error);
    return calculateCustomPrice(basePrice, 1, roundingValue);
  }
}
function isBasketSantJordiProduct() {
  return document.querySelector('.main-product-cont[data-basket-sant-jordi="1"]') != null;
}

/** Year for upcoming April 23 (Sant Jordi); if today is after Apr 23, use next year. */
function getSantJordiCampaignYear() {
  var now = new Date();
  now.setHours(0, 0, 0, 0);
  var y = now.getFullYear();
  var apr23 = new Date(y, 3, 23);
  if (now > apr23) {
    return y + 1;
  }
  return y;
}

/**
 * First selectable day for “choose date” on Sant Jordi basket: April 17 of campaign year,
 * but if today is already on/after that anchor, use the next calendar day (then skip to next
 * basket-allowed day if that lands on a disabled Sat/Sun).
 */
function getSantJordiBasketChooseMinDate() {
  var year = getSantJordiCampaignYear();
  var anchor = new Date(year, 3, 17);
  anchor.setHours(0, 0, 0, 0);
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  var candidate;
  if (today.getTime() < anchor.getTime()) {
    candidate = anchor;
  } else {
    candidate = new Date(today);
    candidate.setDate(candidate.getDate() + 1);
  }
  return getFirstBasketSelectableOnOrAfter(candidate);
}

// Function to calculate express delivery dates based on customer's local timezone and skip weekends
function calculateExpressDeliveryDates() {
  var $expressItem = $('.sdd-item-express');
  if (!$expressItem.length) return;

  function getLocale() {
    var locale = 'en';
    if (window.Shopify && window.Shopify.locale) {
      locale = window.Shopify.locale;
    } else if (document.documentElement.lang) {
      locale = document.documentElement.lang;
    }
    return locale;
  }

  function formatDate(date, format, useLocale) {
    var day = date.getDate();
    var year = date.getFullYear();
    var locale = useLocale !== undefined ? useLocale : getLocale();
    var monthFormatterLong = new Intl.DateTimeFormat(locale, { month: 'long' });
    var monthFormatterShort = new Intl.DateTimeFormat(locale, { month: 'short' });
    var monthNameLong = monthFormatterLong.format(date);
    if (format === 'full') {
      return day + ' ' + monthNameLong + ' ' + year;
    } else if (format === 'short') {
      return monthNameLong + ' ' + day;
    }
    return day + ' ' + monthNameLong + ' ' + year;
  }

  function formatDateForValue(date, useLocale) {
    var day = date.getDate();
    var year = date.getFullYear();
    var locale = useLocale !== undefined ? useLocale : getLocale();
    var monthFormatter = new Intl.DateTimeFormat(locale, { month: 'long' });
    var monthName = monthFormatter.format(date);
    var monthFormatterEn = new Intl.DateTimeFormat('en', { month: 'long' });
    var monthNameEn = monthFormatterEn.format(date);
    return {
      translated: day + ' ' + monthName + ' ' + year,
      english: day + ' ' + monthNameEn + ' ' + year
    };
  }

  // Fixed Sant Jordi basket products: express = 23 Apr; choose-date min = 17 Apr or tomorrow if already on/after 17
  if (isBasketSantJordiProduct()) {
    var year = getSantJordiCampaignYear();
    var apr23 = new Date(year, 3, 23);
    var startDateFormatted = formatDateForValue(apr23);
    var apr23Short = formatDate(apr23, 'short');
    $expressItem.attr('data-value', startDateFormatted.translated);
    $expressItem.attr('data-value-english', startDateFormatted.english);
    $expressItem.attr('data-value-translated', startDateFormatted.translated);
    $('.sdd-outer-item-express .sdd-delivery-date').text(apr23Short);
    var $dateRangeText = $('.sdd-delivery-date.sdsd');
    if ($dateRangeText.length) {
      var locale = getLocale();
      var chooseMin = getSantJordiBasketChooseMinDate();
      var monthFormatter = new Intl.DateTimeFormat(locale, { month: 'long' });
      var monthName = monthFormatter.format(chooseMin);
      var startingPrefix = $dateRangeText.attr('data-starting-text') || 'Starting';
      if (startingPrefix.length) {
        startingPrefix = startingPrefix.charAt(0).toUpperCase() + startingPrefix.slice(1);
      }
      $dateRangeText.text(startingPrefix + ' ' + chooseMin.getDate() + ' ' + monthName + ' ' + chooseMin.getFullYear());
    }
    return;
  }

  // Use customer's local time (JavaScript Date uses browser's timezone)
  var customerDate = new Date(); // Customer's current local time

  // Calculate express start date (next day from customer's current time)
  var expressStartDate = new Date(customerDate);
  expressStartDate.setDate(expressStartDate.getDate() + 1); // Add 1 day (tomorrow)

  // Skip Saturday and Sunday for start date - if tomorrow is Saturday or Sunday, move to Monday
  var dayOfWeek = expressStartDate.getDay(); // 0 = Sunday, 6 = Saturday
  if (dayOfWeek === 0) { // Sunday
    expressStartDate.setDate(expressStartDate.getDate() + 1); // Move to Monday
  } else if (dayOfWeek === 6) { // Saturday
    expressStartDate.setDate(expressStartDate.getDate() + 2); // Move to Monday (skip Saturday and Sunday)
  }

  // Calculate express end date (start date + 2 days, excluding Saturdays and Sundays - gives 3-day range total)
  var expressEndDate = new Date(expressStartDate);
  var daysAdded = 0;
  var targetDays = 2; // Add 2 days from start date (gives 3-day range: start, +1, +2)

  while (daysAdded < targetDays) {
    expressEndDate.setDate(expressEndDate.getDate() + 1);
    dayOfWeek = expressEndDate.getDay();

    // Skip Saturday and Sunday - if we land on Saturday or Sunday, skip to next weekday
    if (dayOfWeek === 0) {
      expressEndDate.setDate(expressEndDate.getDate() + 1); // Move to Monday
      daysAdded++; // Count Monday (Sunday is skipped)
    } else if (dayOfWeek === 6) {
      expressEndDate.setDate(expressEndDate.getDate() + 2); // Move to Monday
      daysAdded++; // Count Monday (Saturday and Sunday are skipped)
    } else {
      daysAdded++;
    }
  }

  // Calculate date after express delivery end date (for date range option)
  var dateAfterExpressEnd = new Date(expressEndDate);
  dateAfterExpressEnd.setDate(dateAfterExpressEnd.getDate() + 1); // Add 1 day

  // Skip weekends for the date after express end
  dayOfWeek = dateAfterExpressEnd.getDay();
  if (dayOfWeek === 0) { // Sunday
    dateAfterExpressEnd.setDate(dateAfterExpressEnd.getDate() + 1); // Move to Monday
  } else if (dayOfWeek === 6) { // Saturday
    dateAfterExpressEnd.setDate(dateAfterExpressEnd.getDate() + 2); // Move to Monday
  }

  // Update data attributes with both English and translated versions
  var startDateFormatted = formatDateForValue(expressStartDate);
  var endDateFormatted = formatDate(expressEndDate, 'short');
  var startDateShort = formatDate(expressStartDate, 'short');

  // Set data attributes: use translated version for display, keep English for API/backend
  $expressItem.attr('data-value', startDateFormatted.translated);
  $expressItem.attr('data-value-english', startDateFormatted.english);
  $expressItem.attr('data-value-translated', startDateFormatted.translated);

  // Update displayed date range (using translated month names)
  $('.sdd-outer-item-express .sdd-delivery-date').text(startDateShort + ' - ' + endDateFormatted);
  // Update date range option text (2 days starting [day] [month])
  var $dateRangeText = $('.sdd-delivery-date.sdsd');
  if ($dateRangeText.length) {
    var baseText = $dateRangeText.attr('data-base-text') || '2 days';
    var startingText = $dateRangeText.attr('data-starting-text') || 'Starting';

    baseText = baseText.replace(/working/gi, '').replace(/\s+/g, ' ').trim();

    var locale = getLocale();
    var day = dateAfterExpressEnd.getDate();
    var monthFormatter = new Intl.DateTimeFormat(locale, { month: 'long' });
    var monthName = monthFormatter.format(dateAfterExpressEnd);

    var dateRangeText = startingText + ' ' + day + ' ' + monthName;
    $dateRangeText.text(dateRangeText);
  }
}

/**
 * Update express-delivery card/vase prices from catalog-pricing API (.com only).
 * Liquid renders Shopify variant.price as fallback; changeMarket overrides with country catalog base + domain margin.
 */
async function updateExpressExtrasPrices(countryCode, languageCode, exchangeRate) {
  if (!window.isComDomain) return;

  const root = document.querySelector('[data-ed-extras]');
  if (!root) return;

  const cardProductId = root.getAttribute('data-ed-card-product-id');
  const vaseProductId = root.getAttribute('data-ed-vase-product-id');
  const cardVariantId = root.getAttribute('data-ed-card-varid');
  const vaseVariantId = root.getAttribute('data-ed-vase-varid');

  const displayCurrency = (localStorage.getItem('floraqueen_user_currency') || '').trim() || 'EUR';
  const locale = languageCode || (window.Shopify && window.Shopify.locale) || 'en';
  const rate = typeof exchangeRate === 'number' && !isNaN(exchangeRate) ? exchangeRate : 1;
  const marginAmount = window?.domainMargin?.amount ? Number(window.domainMargin.amount) : null;
  const marginRounding = window?.domainMargin?.decimalRounding != null && window.domainMargin.decimalRounding !== ''
    ? Number(window.domainMargin.decimalRounding)
    : null;

  async function applyCatalogPrice(productId, variantId, giftType) {
    if (!productId || !variantId || !giftType) return;

    try {
      const catalogPricing = await getCatalogPricing('gid://shopify/Product/' + productId, countryCode);
      if (!catalogPricing || !catalogPricing.prices || !catalogPricing.prices.length) return;

      const priceItem = catalogPricing.prices.find(function (item) {
        const id = item.variant && item.variant.id ? item.variant.id.split('/').pop() : '';
        return id === String(variantId);
      });
      if (!priceItem || !priceItem.price || !priceItem.price.amount) return;

      let finalAmount = parseFloat(priceItem.price.amount) * rate;
      if (isNaN(finalAmount) || finalAmount <= 0) return;

      let adjustedPrice = finalAmount;
      if (marginAmount) {
        adjustedPrice = calculatePrice(finalAmount, marginAmount, marginRounding);
      }

      const giftEl = root.querySelector('[data-ed-gift="' + giftType + '"]');
      const priceContainer = giftEl ? giftEl.querySelector('.ed-gift__price') : null;
      const priceEl = priceContainer ? priceContainer.querySelector('.prod-price') : null;
      if (!priceEl) return;

      const formattedPrice = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: displayCurrency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(adjustedPrice);

      priceEl.textContent = formattedPrice;
      priceEl.setAttribute('data-price', adjustedPrice.toFixed(2));
      if (priceContainer) {
        priceContainer.setAttribute('data-default-price', Math.round(finalAmount * 100));
      }
      priceEl.classList.remove('price-loading');
      priceEl.style.visibility = 'visible';
      console.log('✅ Express ' + giftType + ' price updated:', finalAmount, '→', adjustedPrice, displayCurrency);
    } catch (error) {
      console.error('❌ Failed to update express ' + giftType + ' price:', error);
    }
  }

  await Promise.all([
    applyCatalogPrice(cardProductId, cardVariantId, 'card'),
    applyCatalogPrice(vaseProductId, vaseVariantId, 'vase')
  ]);
}

/**
 * Update addon product prices based on current currency.
 * Updates all .cpm-item prices in the addon product selector.
 */
async function updateAddonPrices() {
  if (!window.isComDomain) return;

  try {
    const addonContainer = document.querySelector(".cpm-outer-cont");
    if (!addonContainer) {
      return;
    }

    const currentCurrency = localStorage.getItem('floraqueen_user_currency')?.trim() || 'EUR';

    // Skip if base currency
    if (currentCurrency === 'EUR') {
      return;
    }

    const exchangeRate = await getExchangeRate(currentCurrency);
    console.log('💱 updateAddonPrices exchange rate:', exchangeRate);

    let domainMargin = parseFloat(window?.domainMargin?.amount) || 1.2;
    let domainRounding = parseFloat(window?.domainMargin?.decimalRounding) || 0.90;

    if (isNaN(domainMargin) || domainMargin <= 0) {
      domainMargin = 1.2;
    }
    if (isNaN(domainRounding)) {
      domainRounding = 0.90;
    }

    const addonItems = addonContainer.querySelectorAll('.cpm-item');

    addonItems.forEach((item) => {
      try {
        const priceContainer = item.querySelector('.cpm-price[data-default-price]');
        if (!priceContainer) return;

        const defaultPriceCents = priceContainer.getAttribute('data-default-price');
        if (!defaultPriceCents) return;

        const basePrice = parseFloat(defaultPriceCents) / 100;
        if (isNaN(basePrice) || basePrice <= 0) return;

        const customPrice = calculateCustomPrice(basePrice, exchangeRate, domainRounding, domainMargin);

        const priceElement = priceContainer.querySelector('.prod-price');
        if (!priceElement) return;

        const languageCode = window.Shopify?.locale || 'en';
        const formattedPrice = new Intl.NumberFormat(languageCode, {
          style: 'currency',
          currency: currentCurrency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(customPrice);

        priceElement.textContent = formattedPrice;
        console.log(`✅ Updated addon price: ${basePrice} → ${customPrice} ${currentCurrency}`);
      } catch (error) {
        console.error('❌ Error updating addon item price:', error);
      }
    });
  } catch (error) {
    console.error('❌ Error updating addon prices:', error);
  }
}

/**
 * Update delivery date prices based on current currency.
 * Updates all .sdd-item prices in the delivery date selector.
 */
async function updateDeliveryDatePrices() {
  if (!window.isComDomain) return;

  try {
    const deliveryDateContainer = document.querySelector(".sdd-outer-cont");
    if (!deliveryDateContainer) {
      return;
    }

    const currentCurrency = localStorage.getItem('floraqueen_user_currency')?.trim() || 'EUR';

    // Only adjust when not using base currency
    if (currentCurrency !== 'EUR') {
      const deliveryDateItems = deliveryDateContainer.querySelectorAll('.sdd-item');

      deliveryDateItems.forEach((item) => {
        try {
          const priceElement = item.querySelector('.sdd-price .prod-price');
          if (!priceElement) return;

          const dataPrice = priceElement.getAttribute('data-price');
          if (!dataPrice) return;

          const basePrice = parseFloat(dataPrice.replace(',', '.'));
          if (isNaN(basePrice) || basePrice <= 0) return;

          const customPrice = basePrice;

          const languageCode = window.Shopify?.locale || 'en';
          const formattedPrice = new Intl.NumberFormat(languageCode, {
            style: 'currency',
            currency: currentCurrency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(customPrice);

          priceElement.textContent = formattedPrice;
          priceElement.setAttribute('data-price', customPrice.toFixed(2).replace('.', ','));
          priceElement.setAttribute('data-currency', currentCurrency);
        } catch (error) {
          console.error('❌ Error updating delivery date item price:', error);
        }
      });
    }
  } catch (error) {
    console.error('❌ Error updating delivery date prices:', error);
  }
}
/**
 * Fetches catalog pricing from the custom API endpoint
 * @param {string} productId - Product GID (e.g., "gid://shopify/Product/9482882679112")
 * @param {string} productId - Product GID (e.g., "gid://shopify/Product/9482882679112")
 * @param {string} countryCode - Country code (e.g., "US", "GB")
 * @returns {Promise<Object>} Response object with market, catalog, currency, and prices array
 */
async function getCatalogPricing(productId, countryCode) {
  const apiUrl = 'https://tech-custom-app.onrender.com/api/catalog-pricing';
  
  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        productId: productId,
        countryCode: countryCode.toUpperCase()
      }),
    });

    if (!response.ok) {
      throw new Error(`API request failed with status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Catalog pricing response:', data);
    return data;
  } catch (error) {
    console.error('Error fetching catalog pricing:', error);
    throw error;  
  }
}

/**
 * Hide all prices on the page (.com only — not .es, .fr, .com.br, .com.tr, etc.)
 */
function hideAllPrices() {
  if (!window.isComDomain) return;

  const selectors = [
    '[data-product-price]',
    '[data-compare-price]',
    '.cpb-price',
    '.cvp-price',
    '.cvp-compareprice',
    '.cvp-price-cont', // Variant picker price container on PDP
    '[data-price-wrapper]',
    '[data-price-container]', // Alternative price container selector
    '[data-ed-extras] .prod-price' // Express-delivery card/vase included prices
  ];
  
  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      el.classList.add('price-loading');
      el.style.visibility = 'hidden'; // Also hide with CSS for immediate effect
    });
  });
  
  console.log('🔒 Prices hidden, waiting for API response...');
}

/**
 * Reveal a single price block after API update (.com only)
 */
function revealPriceBlock(el) {
  if (!window.isComDomain || !el) return;
  el.classList.remove('price-loading');
  el.classList.add('price-loaded');
  el.style.visibility = '';
  el.style.opacity = '';
}

/**
 * True when Liquid price fallback is acceptable (PDP main pricing path).
 * Collection/home grids use API-only reveal via revealPriceBlock.
 */
function shouldRevealLiquidPriceFallback() {
  return !!document.getElementById('product-page-container');
}

/**
 * Show remaining fallback prices after init (.com only, PDP).
 * Collection cards are revealed per-block via revealPriceBlock only.
 */
function showAllPrices() {
  if (!window.isComDomain) return;
  if (!shouldRevealLiquidPriceFallback()) return;

  setTimeout(() => {
    document.querySelectorAll('.price-loading').forEach(el => {
      el.classList.remove('price-loading');
      el.classList.add('price-loaded');
      el.style.visibility = 'visible'; // Make visible
    });
    console.log('✅ Prices displayed');
  }, 1000);
}

/**
 * Parses price string that may have comma as decimal separator (European format)
 * @param {string|number} priceStr - Price string (e.g., "54,90" or "54.90")
 * @returns {number} Parsed price as number
 */
function parsePriceAmount(priceStr) {
  if (typeof priceStr === 'number') {
    return priceStr;
  }
  
  if (typeof priceStr !== 'string') {
    console.warn('parsePriceAmount: Invalid input type', typeof priceStr, priceStr);
    return 0;
  }
  
  // Replace comma with dot for European format (e.g., "54,90" -> "54.90")
  const normalized = priceStr.replace(',', '.');
  const parsed = parseFloat(normalized);
  
  if (isNaN(parsed)) {
    console.warn('parsePriceAmount: Failed to parse', priceStr);
    return 0;
  }
  
  return parsed;
}

/**
 * Formats price with currency symbol (European format with comma)
 * @param {number} amount - Price amount
 * @param {string} currencyCode - Currency code (e.g., 'EUR', 'USD')
 * @returns {string} Formatted price string (e.g., "€49,90" or "$49.90")
 */
function formatPriceEuropean(amount, currencyCode) {
  if (typeof amount !== 'number' || isNaN(amount) || amount <= 0) {
    console.warn('formatPriceEuropean: Invalid amount', amount);
    return '';
  }
  
  // Get currency symbol
  const currencySymbols = {
    'EUR': '€',
    'USD': '$',
    'GBP': '£',
    'PLN': 'zł',
    'DKK': 'kr',
    'SEK': 'kr',
    'NOK': 'kr'
  };

  const upperCode = (currencyCode || '').toUpperCase();
  const symbol = currencySymbols[upperCode] || upperCode;

  // For EUR and most EU-style currencies: use comma as decimal separator (e.g. 70,90 €)
  // For USD/GBP: use dot as decimal separator (e.g. $70.90, £70.90)
  const useDotDecimal = upperCode === 'USD' || upperCode === 'GBP';

  const formatted = useDotDecimal
    ? amount.toFixed(2)                   // 70.90
    : amount.toFixed(2).replace('.', ','); // 70,90

  return `${symbol}${formatted}`;
}

/** Timeout in ms for each catalog API call on collection page; slow/failed calls won't block others */
var COLLECTION_PRICING_REQUEST_TIMEOUT_MS = 10000;

/**
 * Wraps a promise to reject after a timeout (used so one slow request doesn't block all prices)
 */
function withTimeout(promise, ms, label) {
  const timeout = new Promise(function(_, reject) {
    setTimeout(function() {
      reject(new Error('Timeout' + (label ? ' (' + label + ')' : '')));
    }, ms);
  });
  return Promise.race([promise, timeout]);
}

/**
 * Update prices for collection pages
 * Fetches all prices in parallel, then updates all blocks together so prices appear at once.
 * Failed or timed-out requests: that product is skipped (keeps loading/theme default); others still show.
 * Reads data-domain-margin and data-domain-rounding from each element.
 * Uses floraqueen_user_currency from localStorage for display currency; converts from country currency via fetchCurrencyExchangeRate.
 */
async function updateCollectionPagePrices(countryCode) {
  if (!window.isComDomain) return;

  const productBlocks = document.querySelectorAll('.cpb-price[data-product-id]');
  
  if (productBlocks.length === 0) {
    console.log('No product blocks found on collection page');
    return;
  }
  
  console.log(`Updating prices for ${productBlocks.length} products on collection page`);
  
  // --- Currency: display in user-selected currency (localStorage) or EUR ---
  const displayCurrency = (localStorage.getItem('floraqueen_user_currency') || '').trim() || 'EUR';
  const displayCurrencyUpper = displayCurrency.toUpperCase();
  let countryCurrency = 'EUR';
  let effectiveExchangeRate = 1;
  const storefrontEndpoint = '/de-de/api/2024-04/graphql.json';
  const publicAccessToken = '423afb7e832d6a8245c4b1f1e8ade220';
  try {
    const queryCountryCode = {
      "query": "query($countryCode: CountryCode!) @inContext(country: $countryCode) { localization { country { currency { isoCode name symbol } } } }",
      "variables": { "countryCode": (countryCode || 'DE').toUpperCase() }
    };
    const responseCountryCode = await fetch(storefrontEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': publicAccessToken,
      },
      body: JSON.stringify(queryCountryCode),
    });
    const jsonResponseCountryCode = await responseCountryCode.json();
    countryCurrency = jsonResponseCountryCode?.data?.localization?.country?.currency?.isoCode || 'EUR';
    const currencyExchangeRate = await fetchCurrencyExchangeRate(countryCurrency);
    effectiveExchangeRate = (displayCurrencyUpper === countryCurrency)
      ? 1
      : (currencyExchangeRate && currencyExchangeRate[displayCurrencyUpper] != null
          ? currencyExchangeRate[displayCurrencyUpper]
          : 1);
    console.log('Collection pricing: country', countryCode, 'countryCurrency', countryCurrency, 'displayCurrency', displayCurrencyUpper, 'effectiveExchangeRate', effectiveExchangeRate);
  } catch (err) {
    console.warn('Collection page: could not resolve currency/exchange rate, using 1:', err && err.message ? err.message : err);
  }
  
  var timeoutMs = typeof COLLECTION_PRICING_REQUEST_TIMEOUT_MS === 'number' && COLLECTION_PRICING_REQUEST_TIMEOUT_MS > 0
    ? COLLECTION_PRICING_REQUEST_TIMEOUT_MS
    : 10000;
  
  // Step 1: Fetch all prices in parallel with per-request timeout (don't update DOM yet)
  var fetchPromises = [];
  var blockInfos = [];
  
  for (var b = 0; b < productBlocks.length; b++) {
    var block = productBlocks[b];
    var productId = block.getAttribute('data-product-id');
    if (!productId) continue;
    
    blockInfos.push({ block: block, productId: productId });
    (function(pid) {
      var gid = 'gid://shopify/Product/' + pid;
      fetchPromises.push(
        withTimeout(getCatalogPricing(gid, countryCode), timeoutMs, 'product ' + pid).catch(function(err) {
          console.warn('Price fetch failed or timed out for product ' + pid + ':', err && err.message ? err.message : err);
          return null;
        })
      );
    })(productId);
  }
  
  // Wait for all API responses (each resolves with data or null after timeout/failure)
  var pricingResults = await Promise.all(fetchPromises);
  
  // Step 2: Update all blocks in one pass (no await - all DOM updates together)
  let updatedCount = 0;
  for (let i = 0; i < blockInfos.length; i++) {
    const { block, productId } = blockInfos[i];
    const pricingData = pricingResults[i];
    
    if (!pricingData || !pricingData.prices || pricingData.prices.length === 0) {
      continue;
    }
    
    const firstPrice = pricingData.prices[0];
    if (!firstPrice || !firstPrice.price || !firstPrice.price.amount) {
      continue;
    }
    
    // Amounts from catalog are in country currency; convert to display currency (floraqueen_user_currency)
    let priceAmount = parsePriceAmount(firstPrice.price.amount) * effectiveExchangeRate;
    let compareAtPriceAmount = firstPrice.compareAtPrice && firstPrice.compareAtPrice.amount
      ? parsePriceAmount(firstPrice.compareAtPrice.amount) * effectiveExchangeRate
      : null;
    
    if (isNaN(priceAmount) || priceAmount <= 0) {
      continue;
    }
    
    const domainMargin = block.getAttribute('data-domain-margin');
    const domainRounding = block.getAttribute('data-domain-rounding');
    
    if (domainMargin && domainMargin !== '1' && domainMargin !== '') {
      const marginValue = parseFloat(domainMargin);
      if (!isNaN(marginValue) && marginValue > 0) {
        priceAmount = priceAmount * marginValue;
        if (compareAtPriceAmount) {
          compareAtPriceAmount = compareAtPriceAmount * marginValue;
        }
      }
    }
    
    if (domainRounding && domainRounding !== '' && domainRounding !== 'null') {
      const roundingValue = parseFloat(domainRounding);
      if (!isNaN(roundingValue)) {
        priceAmount = calculatePrice(priceAmount, 1, roundingValue);
        if (compareAtPriceAmount) {
          compareAtPriceAmount = calculatePrice(compareAtPriceAmount, 1, roundingValue);
        }
      }
    }
    
    const formattedPrice = formatPriceEuropean(priceAmount, displayCurrencyUpper);
    const formattedComparePrice = compareAtPriceAmount
      ? formatPriceEuropean(compareAtPriceAmount, displayCurrencyUpper)
      : null;
    
    if (!formattedPrice) continue;
    
    if (compareAtPriceAmount && formattedComparePrice && compareAtPriceAmount > priceAmount) {
      block.innerHTML = `
        <span class="compare-price"><span class="money"><span class="prod-price" data-price="${compareAtPriceAmount.toFixed(2).replace('.', ',')}">${formattedComparePrice}</span></span></span>
        <span class="sale-price"><span class="money"><span class="prod-price" data-price="${priceAmount.toFixed(2).replace('.', ',')}">${formattedPrice}</span></span></span>
      `;
    } else {
      block.innerHTML = `
        <span class="money"><span class="prod-price" data-price="${priceAmount.toFixed(2).replace('.', ',')}">${formattedPrice}</span></span>
      `;
    }
    
    revealPriceBlock(block);
    updatedCount++;
  }
  
  console.log(`✅ Updated ${updatedCount} product price(s) - displaying all together`);
}

/**
 * Maps country names to country codes
 * @param {string} countryName - Country name (e.g., "Spain", "Germany")
 * @returns {string} Country code (e.g., "ES", "DE")
 */
function getCountryCodeFromName(countryName) {
  if (!countryName) return null;
  
  // Comprehensive country name to ISO code mapping
  // Optimized: Object lookup is O(1) - very fast even with many entries
  const countryMap = {
    // A
    'afghanistan': 'AF',
    'albania': 'AL',
    'algeria': 'DZ',
    'andorra': 'AD',
    'angola': 'AO',
    'antigua and barbuda': 'AG',
    'argentina': 'AR',
    'armenia': 'AM',
    'australia': 'AU',
    'austria': 'AT',
    'azerbaijan': 'AZ',
    // B
    'bahamas': 'BS',
    'bahrain': 'BH',
    'bangladesh': 'BD',
    'barbados': 'BB',
    'belarus': 'BY',
    'belgium': 'BE',
    'belize': 'BZ',
    'benin': 'BJ',
    'bhutan': 'BT',
    'bolivia': 'BO',
    'bosnia and herzegovina': 'BA',
    'bosnia & herzegovina': 'BA',
    'botswana': 'BW',
    'brazil': 'BR',
    'brasil': 'BR',
    'brunei': 'BN',
    'bulgaria': 'BG',
    'burkina faso': 'BF',
    'burundi': 'BI',
    // C
    'cambodia': 'KH',
    'cameroon': 'CM',
    'canada': 'CA',
    'cape verde': 'CV',
    'central african republic': 'CF',
    'chad': 'TD',
    'chile': 'CL',
    'china': 'CN',
    'colombia': 'CO',
    'comoros': 'KM',
    'congo': 'CG',
    'congo (democratic republic)': 'CD',
    'democratic republic of congo': 'CD',
    'costa rica': 'CR',
    'croatia': 'HR',
    'cuba': 'CU',
    'cyprus': 'CY',
    'czech republic': 'CZ',
    'czechia': 'CZ',
    // D
    'denmark': 'DK',
    'djibouti': 'DJ',
    'dominica': 'DM',
    'dominican republic': 'DO',
    // E
    'ecuador': 'EC',
    'egypt': 'EG',
    'el salvador': 'SV',
    'equatorial guinea': 'GQ',
    'eritrea': 'ER',
    'estonia': 'EE',
    'eswatini': 'SZ',
    'swaziland': 'SZ',
    'ethiopia': 'ET',
    // F
    'fiji': 'FJ',
    'finland': 'FI',
    'france': 'FR',
    // G
    'gabon': 'GA',
    'gambia': 'GM',
    'georgia': 'GE',
    'germany': 'DE',
    'ghana': 'GH',
    'greece': 'GR',
    'grenada': 'GD',
    'guatemala': 'GT',
    'guinea': 'GN',
    'guinea-bissau': 'GW',
    'guyana': 'GY',
    // H
    'haiti': 'HT',
    'honduras': 'HN',
    'hungary': 'HU',
    // I
    'iceland': 'IS',
    'india': 'IN',
    'indonesia': 'ID',
    'iran': 'IR',
    'iraq': 'IQ',
    'ireland': 'IE',
    'israel': 'IL',
    'italy': 'IT',
    'ivory coast': 'CI',
    'côte d\'ivoire': 'CI',
    // J
    'jamaica': 'JM',
    'japan': 'JP',
    'jordan': 'JO',
    // K
    'kazakhstan': 'KZ',
    'kenya': 'KE',
    'kiribati': 'KI',
    'kosovo': 'XK',
    'kuwait': 'KW',
    'kyrgyzstan': 'KG',
    // L
    'laos': 'LA',
    'latvia': 'LV',
    'lebanon': 'LB',
    'lesotho': 'LS',
    'liberia': 'LR',
    'libya': 'LY',
    'liechtenstein': 'LI',
    'lithuania': 'LT',
    'luxembourg': 'LU',
    // M
    'madagascar': 'MG',
    'malawi': 'MW',
    'malaysia': 'MY',
    'maldives': 'MV',
    'mali': 'ML',
    'malta': 'MT',
    'marshall islands': 'MH',
    'mauritania': 'MR',
    'mauritius': 'MU',
    'mexico': 'MX',
    'micronesia': 'FM',
    'moldova': 'MD',
    'monaco': 'MC',
    'mongolia': 'MN',
    'montenegro': 'ME',
    'morocco': 'MA',
    'mozambique': 'MZ',
    'myanmar': 'MM',
    'burma': 'MM',
    // N
    'namibia': 'NA',
    'nauru': 'NR',
    'nepal': 'NP',
    'netherlands': 'NL',
    'new zealand': 'NZ',
    'nicaragua': 'NI',
    'niger': 'NE',
    'nigeria': 'NG',
    'north korea': 'KP',
    'north macedonia': 'MK',
    'macedonia': 'MK',
    'norway': 'NO',
    // O
    'oman': 'OM',
    // P
    'pakistan': 'PK',
    'palau': 'PW',
    'palestine': 'PS',
    'panama': 'PA',
    'papua new guinea': 'PG',
    'paraguay': 'PY',
    'peru': 'PE',
    'philippines': 'PH',
    'poland': 'PL',
    'portugal': 'PT',
    // Q
    'qatar': 'QA',
    // R
    'romania': 'RO',
    'russia': 'RU',
    'rwanda': 'RW',
    // S
    'saint kitts and nevis': 'KN',
    'st kitts and nevis': 'KN',
    'saint lucia': 'LC',
    'st lucia': 'LC',
    'saint vincent and the grenadines': 'VC',
    'st vincent and the grenadines': 'VC',
    'samoa': 'WS',
    'san marino': 'SM',
    'sao tome and principe': 'ST',
    'saudi arabia': 'SA',
    'senegal': 'SN',
    'serbia': 'RS',
    'seychelles': 'SC',
    'sierra leone': 'SL',
    'singapore': 'SG',
    'slovakia': 'SK',
    'slovenia': 'SI',
    'solomon islands': 'SB',
    'somalia': 'SO',
    'south africa': 'ZA',
    'south korea': 'KR',
    'south sudan': 'SS',
    'spain': 'ES',
    'sri lanka': 'LK',
    'sudan': 'SD',
    'suriname': 'SR',
    'sweden': 'SE',
    'switzerland': 'CH',
    'syria': 'SY',
    // T
    'taiwan': 'TW',
    'tajikistan': 'TJ',
    'tanzania': 'TZ',
    'thailand': 'TH',
    'timor-leste': 'TL',
    'east timor': 'TL',
    'togo': 'TG',
    'tonga': 'TO',
    'trinidad and tobago': 'TT',
    'tunisia': 'TN',
    'turkey': 'TR',
    'turkmenistan': 'TM',
    'tuvalu': 'TV',
    // U
    'uganda': 'UG',
    'ukraine': 'UA',
    'united arab emirates': 'AE',
    'uae': 'AE',
    'united kingdom': 'GB',
    'uk': 'GB',
    'great britain': 'GB',
    'united states': 'US',
    'usa': 'US',
    'united states of america': 'US',
    'uruguay': 'UY',
    'uzbekistan': 'UZ',
    // V
    'vanuatu': 'VU',
    'vatican city': 'VA',
    'venezuela': 'VE',
    'vietnam': 'VN',
    // Y
    'yemen': 'YE',
    // Z
    'zambia': 'ZM',
    'zimbabwe': 'ZW'
  };
  
  const normalizedName = countryName.trim().toLowerCase();
  return countryMap[normalizedName] || null;
}

/**
 * Default pricing country for the current domain store
 */
function getDefaultPricingCountry() {
  const defaults = getDomainMarketDefaults();
  if (defaults) {
    return { countryCode: defaults.countryCode, countryName: defaults.country };
  }
  return { countryCode: 'DE', countryName: 'Germany' };
}

/**
 * Gets the country code to use for pricing
 * Priority: Collection metafield > localStorage > domain default
 * @returns {Object} {countryCode, countryName, source}
 */
function getCountryCodeForPricing() {
  // Priority 1: Check collection metafield (if on collection page)
  const collectionContainer = document.querySelector('[data-section-type="collection"]');
  if (collectionContainer) {
    const collectionCountry = collectionContainer.getAttribute('data-collection-country');
    if (collectionCountry && collectionCountry.trim() !== '') {
      const countryCode = getCountryCodeFromName(collectionCountry);
      if (countryCode) {
        console.log('🌍 Using collection metafield country:', collectionCountry, '(', countryCode, ')');
        return {
          countryCode: countryCode,
          countryName: collectionCountry,
          source: 'collection-metafield'
        };
      }
    }
  }
  
  // Priority 2: Check localStorage (customer selected country)
  const storedCountryCode = localStorage.getItem('floraqueen_deliveryCountryCode');
  const storedCountryName = localStorage.getItem('floraqueen_deliveryCountry');
  
  if (storedCountryCode && storedCountryCode.trim() !== '') {
    console.log('🌍 Using country from localStorage:', storedCountryName, '(', storedCountryCode, ')');
    return {
      countryCode: storedCountryCode,
      countryName: storedCountryName || 'Unknown',
      source: 'localStorage'
    };
  }
  
  const defaultCountry = getDefaultPricingCountry();
  console.log('🌍 No country found - defaulting to', defaultCountry.countryName, '(' + defaultCountry.countryCode + ')');
  return {
    countryCode: defaultCountry.countryCode,
    countryName: defaultCountry.countryName,
    source: 'default'
  };
}

/**
 * Initialize pricing for current page
 * Checks collection metafield first, then localStorage, then domain default
 * Hides prices, fetches from API, then shows prices
 */
async function initializePricingForPage() {
  if (!window.isComDomain) return;

  try {
    // Get country code with proper precedence
    const countryInfo = getCountryCodeForPricing();
    const countryCode = countryInfo.countryCode;
    const countryName = countryInfo.countryName;
    const source = countryInfo.source;
    
    // Update localStorage if using collection metafield (for consistency)
    if (source === 'collection-metafield') {
      // Check if country changed
      const previousCountryCode = localStorage.getItem('floraqueen_deliveryCountryCode');
      const countryChanged = previousCountryCode && previousCountryCode !== countryCode;
      
      // Update country
      localStorage.setItem('floraqueen_deliveryCountry', countryName);
      localStorage.setItem('floraqueen_deliveryCountryCode', countryCode);
      
      // If country changed, clear delivery address (old address is for different country)
      if (countryChanged) {
        localStorage.removeItem(STORAGE_KEYS.FULL_ADDRESS);
        localStorage.removeItem(STORAGE_KEYS.CITY_FULL_ADDRESS);
        localStorage.removeItem(STORAGE_KEYS.CITY_COUNTRY);
        localStorage.removeItem(STORAGE_KEYS.CITY_COUNTRY_CODE);
        
        // Also clear from window.floraqueen object if it exists
        if (window.floraqueen) {
          window.floraqueen.fullDeliveryAddress = null;
          window.floraqueen.deliveryCountry = countryName;
          window.floraqueen.deliveryCountryCode = countryCode;
        }
        
        // Clear address input field on PDP if it exists
        const addressInput = document.getElementById('productPageAddressInput');
        if (addressInput) {
          addressInput.value = '';
          // Trigger change event to update UI
          addressInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
        
        // Hide delivery date section if visible
        const deliveryDateSection = document.querySelector('.sdd-outer-cont');
        if (deliveryDateSection) {
          deliveryDateSection.style.display = 'none';
        }
        
        // Clear delivery city/country display elements
        const deliveryCityName = document.querySelector('.delivery-city-name');
        if (deliveryCityName) {
          deliveryCityName.textContent = '';
        }
        
        console.log('🧹 Cleared delivery address due to country change:', previousCountryCode, '→', countryCode);
      }
      
      console.log('💾 Saved collection country to localStorage');
    } else if (source === 'default') {
      // Only set default if not already set (first-time visitor)
      if (!localStorage.getItem('floraqueen_deliveryCountryCode')) {
        localStorage.setItem('floraqueen_deliveryCountry', countryName);
        localStorage.setItem('floraqueen_deliveryCountryCode', countryCode);
      }
    }
    
    // Hide prices
    hideAllPrices();
    
    // Check if product page
    const productContainer = document.getElementById('product-page-container');
    if (productContainer) {
      // Product page - use existing changeMarket function
      console.log('📦 Product page detected - initializing pricing');
      await changeMarket(countryCode);
    } else {
      // Collection or other page - fetch prices for all products
      console.log('📋 Collection/other page detected - initializing pricing');
      await updateCollectionPagePrices(countryCode);
    }
    
    // PDP only: reveal any remaining Liquid fallbacks (e.g. related product cards)
    showAllPrices();
    console.log('✅ Pricing initialization complete');
  } catch (error) {
    console.error('❌ Error initializing pricing:', error);
    showAllPrices();
  }
}

/**
 * Fetches product prices via GraphQL and updates the page, then re-initializes form logic.
 * FINAL VERSION: Locks currency and applies a price modifier based on destination.
 */
async function changeMarket(countryCode, languageCode = 'en') {
  if (!window.isComDomain) return;

  // Hide prices at start
  hideAllPrices();
  
  // --- CONFIGURATION ---
  const storefrontEndpoint = '/de-de/api/2024-04/graphql.json';
  const publicAccessToken = '423afb7e832d6a8245c4b1f1e8ade220';

  // --- GET DYNAMIC DATA ---
  const productContainer = document.getElementById('product-page-container');
  const productId = productContainer ? productContainer.dataset.productId : null;
  if (!productId) {
    const collectionBlocks = document.querySelectorAll('.cpb-price[data-product-id]');
    if (collectionBlocks.length > 0) {
      await updateCollectionPagePrices(countryCode);
    }
    showAllPrices();
    return;
  }
  const productGid = `gid://shopify/Product/${productId}`;

  // --- GET CURRENT MARKET's COUNTRY ---
  console.log('window.Shopify ', window.Shopify);
  const currentMarketCountry = window.Shopify.country;
  if (!currentMarketCountry) {
    console.error("Could not determine the current market's country. Aborting price update.");
    return;
  }
  console.log('currentMarketCountry', currentMarketCountry);
  console.log("--- Starting Market Change ---");
  console.log(`Incoming destination country code: "${countryCode}"`);
  console.log(`Base context (for currency): "${currentMarketCountry}"`);

  // Display currency: from localStorage (user selection) or default EUR (Germany price)
  const displayCurrency = (localStorage.getItem('floraqueen_user_currency') || '').trim() || 'EUR';
  const currentMarketCurrencyCode = displayCurrency.toUpperCase();
  console.log('Display currency (from localStorage):', currentMarketCurrencyCode);

  let currencyExchangeRate = null;
  let IncomingIsoCode = null;
  let IncomingCurrencySymbol = null;
  try {
    /*---- Fetch CountryCode (for country passed from localStorage or default DE) ----*/
    const queryCountryCode = {
      "query": "query($countryCode: CountryCode!) @inContext(country: $countryCode) { localization { country { currency { isoCode name symbol } } } }",
      "variables": {
        "countryCode": countryCode.toUpperCase()
      }
    };
    const responseCountryCode = await fetch(storefrontEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': publicAccessToken,
      },
      body: JSON.stringify(queryCountryCode),
    });
    const jsonResponseCountryCode = await responseCountryCode.json();
    IncomingIsoCode = jsonResponseCountryCode?.data?.localization?.country?.currency?.isoCode;
    IncomingCurrencySymbol = jsonResponseCountryCode?.data?.localization?.country?.currency?.symbol;
    console.log('Incoming country isoCode', IncomingIsoCode, 'currencySymbol', IncomingCurrencySymbol);
    /*---- EOF Fetch CountryCode ----*/
    /*---- Fetch Currency Exchange Rate (from country currency) ----*/
    currencyExchangeRate = await fetchCurrencyExchangeRate(IncomingIsoCode);
    console.log('currencyExchangeRate', currencyExchangeRate);
    /*---- EOF Fetch Currency Exchange Rate ----*/
  } catch (error) {
    console.log('Error fetching country code:', error);
  }

  // Rate from country currency to display currency: 1 if same, else from API map
  const effectiveExchangeRate = (currentMarketCurrencyCode === IncomingIsoCode)
    ? 1
    : (currencyExchangeRate && currencyExchangeRate[currentMarketCurrencyCode] != null
        ? currencyExchangeRate[currentMarketCurrencyCode]
        : 1);
  console.log('Effective exchange rate to display currency:', effectiveExchangeRate);

  // --- GRAPHQL QUERY ---
  const query = `
    query getProductPriceInContext($id: ID!, $countryCode: CountryCode!) @inContext(country: $countryCode) {
      product(id: $id) {
        variants(first: 10) {
          edges {
            node {
              id
              title
              price {
                amount
                currencyCode
              }
              compareAtPrice {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  `;

  const variables = {
    "id": productGid,
    "countryCode": countryCode.toUpperCase()
    //"countryCode": currentMarketCountry.toUpperCase()
  };

  // --- API REQUEST ---
  try {
    const response = await fetch(storefrontEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': publicAccessToken,
      },
      body: JSON.stringify({ query, variables }),
    });

    const jsonResponse = await response.json();
    if (jsonResponse.errors) throw new Error(jsonResponse.errors.map(e => e.message).join("\n"));
    if (!jsonResponse.data.product) {
      console.error("API returned a null product for the current market.");
      return;
    }

    // --- GET CATALOG PRICING ---
    let catalogPricing = null;
    try {
      catalogPricing = await getCatalogPricing(productGid, countryCode);
      console.log('Catalog pricing data:', catalogPricing);
      // catalogPricing contains: market, catalog, currency, and prices array
      // Each price object has: variant (id, title, sku), price (amount, currencyCode), compareAtPrice
    } catch (error) {
      console.error('Failed to fetch catalog pricing:', error);
      // Continue execution even if catalog pricing fails
    }

    // --- ENHANCED DEBUGGING: PRICE MODIFIER LOGIC ---
    const priceModifiers = window.floraqueen.priceModifier || [];
    const destinationModifierData = priceModifiers.find(
      item => item["Country code"] && item["Country code"].trim().toUpperCase() === countryCode.trim().toUpperCase()
    );

    let modifier = 0; // Default fallback modifier value
    let modifierType = 'none'; // 'percentage' or 'flat'

    // Prepare modifier value and type
    if (destinationModifierData) {
      const modifierRaw = destinationModifierData["% modifier"];
      const modifierOption = (destinationModifierData["Price modifier option"] || "").trim();

      if (typeof modifierRaw === 'string' || typeof modifierRaw === 'number') {
        const parsedModifier = parseFloat(modifierRaw);
        
        if (!isNaN(parsedModifier)) {
          if (modifierOption === '%') {
            modifier = 1 + parsedModifier / 100;  // for multiplication
            modifierType = 'percentage';
            console.log(`✅ Percentage modifier detected: +${parsedModifier}%`);
          } else {
            modifier = parsedModifier*Shopify.currency.rate; // flat value
            console.log(modifier*Shopify.currency.rate)
            console.log(Shopify.currency.rate)
            modifierType = 'flat';
            console.log(`✅ Currency modifier detected: +${modifierOption}${parsedModifier}`);
          }
        } else {
          console.log(`⚠️ Invalid modifier number: ${modifierRaw}`);
        }
      } else {
        console.log(`⚠️ "% modifier" not a number or string:`, modifierRaw);
      }
    } else {
      console.log(`ℹ️ No modifier found for country: ${countryCode}`);
    }

    // --- UPDATE PRICES ON THE UI ---
    console.log('*jsonResponse---------------------------------------------------------------------', jsonResponse);
    
    // Use catalog pricing if available, otherwise fall back to GraphQL response
    let variants = null;
    let useCatalogPricing = false;
    
    if (catalogPricing && catalogPricing.prices && catalogPricing.prices.length > 0) {
      variants = catalogPricing.prices;
      useCatalogPricing = true;
      console.log('Using catalog pricing data for variants');
    } else {
      variants = jsonResponse.data.product.variants.edges;
      console.log('Using GraphQL response data for variants');
    }
    
    variants.forEach(priceItem => {
      let variant, variant_Id, basePrice, compareAtPrice;
      
      if (useCatalogPricing) {
        // Catalog pricing structure: { variant: { id, title, sku }, price: { amount, currencyCode }, compareAtPrice }
        variant = priceItem.variant;
        variant_Id = variant.id.split("/").pop();
        basePrice = priceItem.price;
        compareAtPrice = priceItem.compareAtPrice || null;
      } else {
        // GraphQL structure: { node: { id, price: { amount, currencyCode }, compareAtPrice } }
        variant = priceItem.node;
        variant_Id = variant.id.split("/").pop();
        basePrice = variant.price;
        compareAtPrice = variant.compareAtPrice || null;
      }
      
      console.log('variant', variant);
      
      let finalAmount;
      let finalCompareAmount;
      
      // Base amount is in country currency (from getCatalogPricing/countryCode or GraphQL). Convert to display currency.
      finalAmount = parseFloat(basePrice.amount) * effectiveExchangeRate;
      if (compareAtPrice && compareAtPrice.amount) {
        finalCompareAmount = parseFloat(compareAtPrice.amount) * effectiveExchangeRate;
      } else {
        finalCompareAmount = null;
      }

      // Fallback in case of invalid calculation
      if (isNaN(finalAmount) || finalAmount < 0) {
        finalAmount = parseFloat(basePrice.amount);
        console.log(`⚠️ Final amount invalid for variant ${variant_Id}, using base price.`);
      }
      if (finalCompareAmount !== null && (isNaN(finalCompareAmount) || finalCompareAmount < 0)) {
        finalCompareAmount = compareAtPrice ? parseFloat(compareAtPrice.amount) : null;
        console.log(`⚠️ Final compare amount invalid for variant ${variant_Id}, using compare at price.`);
      }
      
      // Use currency from catalog pricing if available, otherwise use current market currency
      const displayCurrency = useCatalogPricing && catalogPricing.currency 
        ? catalogPricing.currency 
        : currentMarketCurrencyCode;

      console.log(`Variant ID: ${variant_Id} | Base Price: ${basePrice.amount} | Final Amount: ${finalAmount}`);
      console.log(`Variant ID: ${variant_Id} | Compare At Price: ${compareAtPrice?.amount} | Final Compare Amount: ${finalCompareAmount}`);

      const variantContainer = document.querySelector(`[data-variant="${variant_Id}"]`);
      const cvpPriceWrapper = document.querySelector(`.cvp-price-wrapper`);
      if (variantContainer) {
          const priceElement = variantContainer.querySelector('.cvp-price');
          const comparePriceElement = variantContainer.querySelector('.cvp-compareprice');
          const priceContainer = variantContainer.querySelector('.cvp-price-cont, [data-price-container]');
          
          if (priceElement) {
            let adjustedPrice = Math.floor(finalAmount) + 0.90;
            console.log('window?.domainMargin ',window?.domainMargin);
            if(window?.domainMargin?.amount){
              adjustedPrice = calculatePrice(Number(finalAmount),Number(window?.domainMargin?.amount), Number(window?.domainMargin?.decimalRounding));
            }
            
            const formattedPrice = new Intl.NumberFormat(languageCode, {
              style: 'currency',
              //currency: basePrice.currencyCode
              currency: currentMarketCurrencyCode,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(adjustedPrice);
            
            priceElement.textContent = formattedPrice;
            
            // Store the applied price in data attribute for cart operations
            variantContainer.setAttribute('data-applied-price', adjustedPrice.toFixed(2));
            
            // Show price container if it was hidden
            if (priceContainer) {
              priceContainer.classList.remove('price-loading');
              priceContainer.style.visibility = 'visible';
            }
          }
          if(comparePriceElement){
            if (finalCompareAmount !== null && !isNaN(finalCompareAmount)) {
              let adjustedComparePrice = Math.floor(finalCompareAmount) + 0.90;
              if(window?.domainMargin?.amount){
                adjustedComparePrice = calculatePrice(Number(finalCompareAmount),Number(window?.domainMargin?.amount), Number(window?.domainMargin?.decimalRounding));
              
              }
              const formattedComparePrice = new Intl.NumberFormat(languageCode, {
                style: 'currency',
                //currency: basePrice.currencyCode
                currency: currentMarketCurrencyCode,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(adjustedComparePrice);
              comparePriceElement.textContent = formattedComparePrice;
              comparePriceElement.style.display = '';
            } else {
              comparePriceElement.style.display = 'none';
            }
          }
      }
      // Update prices in cvp-price-wrapper if it exists
      if (cvpPriceWrapper) {
        const wrapperPriceElement = cvpPriceWrapper.querySelector('.cvp-price');
        const wrapperComparePriceElement = cvpPriceWrapper.querySelector('.cvp-compareprice');
        
        if (wrapperPriceElement) {
          let adjustedPrice = Math.floor(finalAmount) + 0.90;
          if(window?.domainMargin?.amount){
            adjustedPrice = calculatePrice(Number(finalAmount),Number(window?.domainMargin?.amount), Number(window?.domainMargin?.decimalRounding));
          }
          const formattedPrice = new Intl.NumberFormat(languageCode, {
            style: 'currency',
            currency: currentMarketCurrencyCode,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(adjustedPrice);
          wrapperPriceElement.textContent = formattedPrice;
        }
        
        if (wrapperComparePriceElement) {
          if (finalCompareAmount !== null && !isNaN(finalCompareAmount)) {
            let adjustedComparePrice = Math.floor(finalCompareAmount) + 0.90;
            if(window?.domainMargin?.amount){
              adjustedComparePrice = calculatePrice(Number(finalCompareAmount),Number(window?.domainMargin?.amount), Number(window?.domainMargin?.decimalRounding));
            
            }
            const formattedComparePrice = new Intl.NumberFormat(languageCode, {
              style: 'currency',
              currency: currentMarketCurrencyCode,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(adjustedComparePrice);
            wrapperComparePriceElement.textContent = formattedComparePrice;
            wrapperComparePriceElement.style.display = '';
          } else {
            wrapperComparePriceElement.style.display = 'none';
          }
        }
      }
    });

    const delivery_date = document.querySelector(".sdd-outer-cont");
    // Hide delivery date section for wallart products
    if (delivery_date && !isWallartProduct()) {
      delivery_date.style.display = "block";

      // Always run normal logic first
      // Then override for special countries and reinitialize datepicker
      setTimeout(function() {
        reinitializeDatePicker();
      }, 50);

      // Update delivery date prices for current currency
      updateDeliveryDatePrices();
    } else if (delivery_date && isBasketProduct()) {
      delivery_date.style.display = "block";
    } else if (delivery_date && isWallartProduct()) {
      delivery_date.style.display = "none";
    }

    calculateExpressDeliveryDates();
    await updateExpressExtrasPrices(countryCode, languageCode, effectiveExchangeRate);
    console.log("Market change logic complete.");

    // Show prices after update
    showAllPrices();

    // Update addon prices after all PDP prices are updated
    updateAddonPrices();

  } catch (error) {
    console.error('Error during market change:', error);
    // Show prices even on error to prevent blank page
    showAllPrices();
  }
}

// Handle market change based on country code
function handleMarketChange(countryCode) {
  if (!window.isComDomain) return;

  if (!countryCode) {
    console.error("Cannot handle market change: Country code is missing");
    return;
  }

  console.log(`Handling market change for: ${countryCode}`);

  // Check if the country is available in localization
  if (isCountryInLocalization(countryCode)) {
    // Country is available, use it
    console.log(`${countryCode} is available in localization, using it`);
    changeMarket(countryCode);
  } else {
    // Country not available, use default
    console.log(`${countryCode} is NOT available in localization, using default: ${DEFAULT_MARKET}`);
    changeMarket(DEFAULT_MARKET);
  }
}

function getStorefrontLocale() {
  if (window.Shopify && window.Shopify.locale) {
    return window.Shopify.locale;
  }
  if (document.documentElement && document.documentElement.lang) {
    return document.documentElement.lang;
  }
  return 'en';
}

function getStorefrontLanguageCode() {
  return getStorefrontLocale().toLowerCase().replace(/-/g, '_').toUpperCase();
}

async function updateCartBuyerIdentity(buyerCountryCode) {
  if (!buyerCountryCode) return null;

  const storefrontEndpoint = ((window.Shopify?.routes?.root || '/').replace(/\/$/, '')) + '/api/2024-04/graphql.json';
  const publicAccessToken = '423afb7e832d6a8245c4b1f1e8ade220';
  const cartRes = await fetch('/cart.js');
  if (!cartRes.ok) return null;

  const cart = await cartRes.json();
  if (!cart.token) return null;

  const cartId = `gid://shopify/Cart/${cart.token}`;
  const languageCode = getStorefrontLanguageCode();
  const responseCountryCode = await fetch(storefrontEndpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': publicAccessToken,
    },
    body: JSON.stringify({
      query: `mutation cartBuyerIdentityUpdate($cartId: ID!, $countryCode: CountryCode!, $language: LanguageCode!) @inContext(language: $language) {
        cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: { countryCode: $countryCode }) {
          cart { id }
          userErrors { field message }
        }
      }`,
      variables: {
        cartId,
        countryCode: buyerCountryCode.toUpperCase(),
        language: languageCode
      }
    }),
  });
  const jsonResponseCountryCode = await responseCountryCode.json();
  const userErrors = jsonResponseCountryCode?.data?.cartBuyerIdentityUpdate?.userErrors;
  if (userErrors && userErrors.length) {
    console.warn('cartBuyerIdentityUpdate userErrors:', userErrors);
  }
  return jsonResponseCountryCode;
}

function getStoredDeliveryCountryCode() {
  if (window.floraqueen && window.floraqueen.deliveryCountryCode) {
    return window.floraqueen.deliveryCountryCode;
  }
  if (typeof STORAGE_KEYS !== 'undefined' && localStorage.getItem(STORAGE_KEYS.COUNTRY_CODE)) {
    return localStorage.getItem(STORAGE_KEYS.COUNTRY_CODE);
  }
  if (typeof STORAGE_KEYS !== 'undefined' && localStorage.getItem(STORAGE_KEYS.CITY_COUNTRY_CODE)) {
    return localStorage.getItem(STORAGE_KEYS.CITY_COUNTRY_CODE);
  }
  try {
    return new URLSearchParams(window.location.search || '').get('country_code');
  } catch (e) {
    return null;
  }
}

function getCheckoutUrlWithDeliveryCountry(countryCode) {
  const params = new URLSearchParams();
  params.set('locale', getStorefrontLocale());
  const code = (countryCode || getStoredDeliveryCountryCode() || '').toString().trim();
  if (code) {
    params.set('checkout[shipping_address][country]', code.toUpperCase());
  }
  const query = params.toString();
  return query ? '/checkout?' + query : '/checkout';
}

window.floraqueen = window.floraqueen || {};
window.floraqueen.updateCartBuyerIdentity = updateCartBuyerIdentity;
window.floraqueen.getStoredDeliveryCountryCode = getStoredDeliveryCountryCode;
window.floraqueen.getCheckoutUrlWithDeliveryCountry = getCheckoutUrlWithDeliveryCountry;
window.floraqueen.getStorefrontLocale = getStorefrontLocale;

// Function to update checkout links with storefront locale and delivery country
function updateCheckoutLinksWithCountry() {
  const countryCode = getStoredDeliveryCountryCode();
  const newCheckoutUrl = getCheckoutUrlWithDeliveryCountry(countryCode);

  document.querySelectorAll('a').forEach(function (link) {
    const href = link.getAttribute('href');
    if (href && (href === '/checkout' || href.startsWith('/checkout?'))) {
      link.setAttribute('href', newCheckoutUrl);
    }
  });

  const checkoutButton = document.getElementById('continue-to-delivery-link');
  if (checkoutButton) {
    checkoutButton.dataset.checkoutUrl = newCheckoutUrl;
  }

  if (countryCode) {
    console.log('Checkout links updated with delivery country code:', countryCode);
  }

  return countryCode || null;
}

// Load saved address data from localStorage
function loadSavedAddressData() {
  // Check if URL has city or country parameter - if so, don't load normal address data
  const urlParams = new URLSearchParams(window.location.search);
  const cityParam = urlParams.get('city');
  const countryParam = urlParams.get('country');
  if (cityParam || countryParam) {
    // URL has city or country parameter - skip loading normal address data
    // City/country-based address will be loaded separately
    return;
  }
  
  const fullAddress = localStorage.getItem(STORAGE_KEYS.FULL_ADDRESS);
  const country = localStorage.getItem(STORAGE_KEYS.COUNTRY);
  const countryCode = localStorage.getItem(STORAGE_KEYS.COUNTRY_CODE);

  if (fullAddress) window.floraqueen.fullDeliveryAddress = fullAddress;
  if (country) window.floraqueen.deliveryCountry = country;
  if (countryCode) window.floraqueen.deliveryCountryCode = countryCode;

  if (country || countryCode) {
    console.log("Loaded saved delivery details:", {
      fullAddress: window.floraqueen.fullDeliveryAddress || "Not saved",
      country: window.floraqueen.deliveryCountry || "Not saved",
      countryCode: window.floraqueen.deliveryCountryCode || "Not saved"
    });

    evaluateCountryShipping(window.floraqueen.deliveryCountry, window.floraqueen.deliveryCountryCode);

    // If we have an address and an input field exists, update its value
    const addressInput = document.getElementById("productPageAddressInput");
    if (addressInput && fullAddress) {
      addressInput.value = fullAddress;
    }

    // Only trigger market change for delivery address, not for currency selector
    // This should only run when loading saved delivery data, not when user changes currency
    if (countryCode && !window.floraqueen.isLoadingSavedData) {
      window.floraqueen.isLoadingSavedData = true;
      setTimeout(() => {
        handleMarketChange(countryCode);
        window.floraqueen.isLoadingSavedData = false;
        // Update checkout links after address data is loaded
        updateCheckoutLinksWithCountry();
      }, 1000); // Delay to avoid conflicts with currency selector
    } else if (countryCode) {
      // Update checkout links even if market change is skipped
      setTimeout(function() {
        updateCheckoutLinksWithCountry();
      }, 500);
    }
  }
}

// Fetch data and store in floraqueen object
Promise.all([
  fetchSheetData(priceModifierUrl),
  fetchSheetData(countryCodesUrl)
]).then(([priceModifierData, countryCodesData]) => {
  window.floraqueen.priceModifier = priceModifierData;
  window.floraqueen.countryCodes = countryCodesData;
  console.log('Data loaded successfully');

  // Load saved address data after country codes are loaded
  loadSavedAddressData();
}).catch(error => {
  console.error('Error loading data:', error);

  // Even if there's an error with the data, still try to load saved address
  loadSavedAddressData();
});

// selecting the Select delivery date
document.querySelectorAll('.sdd-item').forEach(item => {
  item.addEventListener('click', function(event) {
    const addon_wrapper = document.querySelector(".cpm-outer-cont");
    const atc_container = document.querySelector("#atc-form-container");
    $('.select-del-date').addClass('hidden');
    if(atc_container)
      atc_container.style.display = "block";
    if(addon_wrapper)
      addon_wrapper.style.display = "block";
    document.querySelectorAll('.sdd-item').forEach(elem => {
        elem.classList.remove('sdd-active')
    })
    item.classList.add('sdd-active')
  });
});

// selecting the Choose the perfect match for your bouquet
$('.cpm-outer-cont:not(.section-addon-page) .cpm-item').each(function() {
    $(this).find('.cpm-right').on('click', () => {
        $(this).toggleClass('cpm-active');
    });
});

$(document).on('click', '.section-addon-page .cpm-right', function (e) {
  const $button = $(this);
  const $wrapper = $(this).closest('.cpm-item');
  const variantId = parseInt($wrapper.data('varid'), 10); // variant ID must be stored in data-varid

  if (isNaN(variantId)) {
    console.error('Invalid variant ID');
    return;
  }

  // If button has 'active' class → Remove product from cart
  if ($wrapper.hasClass('cpm-active')) {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const item = cart.items.find(i => i.variant_id === variantId);
        if (!item) {
          console.warn('Product not found in cart');
          $wrapper.addClass('cpm-active')
          return;
        }

        // Remove item using its line number (1-based index in Shopify)
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: item.key,
            quantity: 0
          })
        });
      })
      .then(res => res?.json?.())
      .then(data => {
        console.log('Product removed from cart:', data);
        $wrapper.removeClass('cpm-active');
      })
      .catch(err => {
        console.error('Error removing product from cart:', err);
      });
  } else {
    // Add item to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
      .then(res => {
        if (!res.ok) throw new Error('Failed to add product');
        return res.json();
      })
      .then(data => {
        console.log('Product added to cart:', data);
        $wrapper.addClass('cpm-active');
      })
      .catch(err => {
        console.error('Error adding product to cart:', err);
      });
  }
})

$(document).on('click', '#delivery-details-block .delivery-change-link', function (e) {
  const delivery_details_city_block = document.querySelector("#delivery-details-block .cdc-default-city");
  const delivery_details_normal_block = document.querySelector("#delivery-details-block .cdc-default-normal");
  if(delivery_details_city_block){
    delivery_details_city_block.style.display = 'none';
  }
  if(delivery_details_normal_block){
    delivery_details_normal_block.style.display = 'block';
  }
});
$(document).on('click', 'button#delete-location, .pdp-error-button', function (e) {
    e.preventDefault();
    if(e.target.className.includes('pdp-error-button')){
        $('.pdp-error-modal').removeClass('active');
    } 
  
    $('#productPageAddressInput').val('');
    const addressInput = document.getElementById('productPageAddressInput');
    if (addressInput) {
      addressInput.value = '';
      // Re-enable the input if it was disabled
      addressInput.disabled = false;
      addressInput.style.backgroundColor = '';
      addressInput.style.cursor = '';
      
      // Show the delete button again
      const deleteButton = document.getElementById('delete-location');
      if (deleteButton) {
        deleteButton.style.display = '';
      }
    }
    const delivery_date = document.querySelector(".sdd-outer-cont");
    const sdd_active = document.querySelector(".sdd-item.sdd-active");
    const atc_container = document.querySelector(".cpm-outer-cont");
    if(delivery_date)
      delivery_date.style.display = "none";
    if(sdd_active)
      sdd_active.classList.remove("sdd-active");
    if(atc_container)
      atc_container.style.display = "none";
    
    // Check if we're in city-based scenario (URL has city parameter)
    const urlParams = new URLSearchParams(window.location.search);
    const cityParam = urlParams.get('city');
    
    if (cityParam) {
      // Clear city-based storage
      clearCityAddressData();
    } else {
      // Clear normal address storage
      localStorage.removeItem(STORAGE_KEYS.FULL_ADDRESS);
      localStorage.removeItem(STORAGE_KEYS.COUNTRY);
      localStorage.removeItem(STORAGE_KEYS.COUNTRY_CODE);
    }
    
    // Clear from floraqueen object
    if (window.floraqueen) {
      window.floraqueen.fullDeliveryAddress = null;
      window.floraqueen.deliveryCountry = null;
      window.floraqueen.deliveryCountryCode = null;
    }
    toggleNonShippingMessage(false);
})

$(document).on('click', '[data-add-to-cart]', function (e) {
  e.preventDefault();
  const $button = $(this);
  const $form = $button.closest('form');

  // Step 2: Fetch current cart first
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const itemCount = cart.item_count;

      // If needed, you could display a popup here using cart data
      if (itemCount) {
        let price = getCookie('current_prd_price');
        fetch('/cart/clear.js')
          .then(res => res.json())
          .then(cart => {
            console.log("empty cart", cart);
          })
          .catch(err => console.error(err));
          return;
        return;
      }else{

        const input = document.querySelector("#productPageAddressInput");
        
        if (input && input.value.trim() === "") {
          $('.cdc-title').css('color', '#c64e14');
          setTimeout(function () {
            $('.cdc-title').css('color', '');
          }, 1500);
          input.focus();
          return false; // In a function context
        }
        
          // Step 1: Ensure a delivery date is selected (skip for wallart products)
        if (!isWallartProduct() && $(document).find('.sdd-item.sdd-active').length === 0) {
          $('.sdd-title').css('color', '#c64e14');
          $('.select-del-date').removeClass('hidden');
          setTimeout(function () {
            $('.sdd-title').css('color', '');
          }, 1500);
          return false;
        }

        // Extract the main variant ID from the form
        const mainVariantId = parseInt($form.find('[name="id"] option:selected').val(), 10);
        const cogsProp = $form.find('#cogs-prop').val();
        const mainVariantName = $form.find('[name="id"] option:selected')[0].label;
        if (isNaN(mainVariantId)) {
          console.error('Invalid variant ID');
          return;
        }

        // Initialize the items array with the main product
        let address = $('#productPageAddressInput').val();
        let del_date_element = $(document).find('.sdd-item.sdd-active');
        let del_date = '';
        let del_date_english = '';
        
        // Only get delivery date if not a wallart product
        if (!isWallartProduct()) {
          if($(document).find('.del-info-personalize').length){
            // For personalize products, use the data-value attribute
            del_date = $(document).find('.del-info-personalize').attr('data-value');
            del_date_english = del_date; // Use the same value for both
          }else if(del_date_element.length && del_date_element.hasClass('sdd-item-3')){
            // For custom date picker (sdd-item-3)
            del_date = del_date_element.find('#del-date').val();
            del_date_english = del_date; // Use the same value for both
          }else if(del_date_element.length){
            // For predefined dates (sdd-item-1, sdd-item-2)
            del_date = del_date_element.attr('data-value-translated') || del_date_element.data('value');
            del_date_english = del_date_element.attr('data-value-english') || del_date_element.data('value');
          }
        }
        
        const properties = {};

        $form.find('[name^="properties["]').each(function () {
          const match = this.name.match(/^properties\[(.+)\]$/);
          if (match) {
            properties[match[1]] = $(this).val();
          }
        });
        
        // Only add delivery date properties if not a wallart product and date exists
        if (!isWallartProduct() && del_date) {
          // Get the translated delivery date key
          const deliveryDateKey = $('.sdd-outer-cont').data('delivery-date-key') || 'Delivery Date';
          properties['_Delivery Date'] = del_date_english; // Hidden field for integrations (English)
          properties[deliveryDateKey] = del_date; // Add the localized date as a visible property
        }
        
        if (cogsProp) {
          properties['_cogs'] = cogsProp;
        }

        // Get applied price from variant container
        const mainVariantContainer = document.querySelector(`[data-variant="${mainVariantId}"]`);
        if (mainVariantContainer) {
          const appliedPrice = mainVariantContainer.getAttribute('data-applied-price');
          if (appliedPrice) {
            properties['__appliedPrice'] = appliedPrice;
          }
        }
        
        const items = [{
          id: mainVariantId,
          quantity: 1,
          properties: properties
        }];

        // Loop through additional selected items
        $('.cpm-item.cpm-active').each(function () {
          const variantId = parseInt($(this).data('varid'), 10);
          let cogsProp_1 = $(this).data('cogs');
          let properties_1 = {};
          
          if (cogsProp_1) {
            properties_1['_cogs'] = cogsProp_1;
          }

          // Get applied price from variant container
          const variantContainer = document.querySelector(`[data-variant="${variantId}"]`);
          if (variantContainer) {
            const appliedPrice = variantContainer.getAttribute('data-applied-price');
            if (appliedPrice) {
              properties_1['__appliedPrice'] = appliedPrice;
            }
          }
          
          if (!isNaN(variantId)) {
            items.push({ id: variantId, quantity: 1, properties: properties_1 });
          }
        });

        let i_l_y = $('.cpm-item.ily-add:not(.cpm-active)').data('varid');
        let i_l_y_cogs = $('.cpm-item.ily-add:not(.cpm-active)').data('cogs');
        if (typeof i_l_y !== 'undefined' && i_l_y !== null) {
          let i_l_y_properties = {};
          
          if (i_l_y_cogs) {
            i_l_y_properties['_cogs'] = i_l_y_cogs;
          }

          // Get applied price from variant container
          const i_l_y_parsed = parseInt(i_l_y, 10);
          if (!isNaN(i_l_y_parsed)) {
            const i_l_y_variantContainer = document.querySelector(`[data-variant="${i_l_y_parsed}"]`);
            if (i_l_y_variantContainer) {
              const appliedPrice = i_l_y_variantContainer.getAttribute('data-applied-price');
              if (appliedPrice) {
                i_l_y_properties['__appliedPrice'] = appliedPrice;
              }
            }
          }

          i_l_y = parseInt(i_l_y, 10);
          if (!isNaN(i_l_y)) {
            items.push({ id: i_l_y, quantity: 1, properties: i_l_y_properties });
          }
        }

        // Bouquets + Classic/Premium: also add Sandy + I Love You companions
        appendBouquetClassicPremiumCompanions(
          items,
          getAtcProductType($button),
          getSelectedVariantLabel(mainVariantName)
        );

        let multplierData = null;
        if (localStorage.getItem(STORAGE_KEYS.COUNTRY_CODE) !== floraqueen.user_country.country.handle) {
            multplierData = floraqueen.priceModifier.find(
                item => item["Country code"] === floraqueen.user_country.country.handle
            );
        }

        // Step 4: Add to cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        })
        .then(response => {
          if (!response.ok) {
            return response.json().then(err => Promise.reject(err));
          }
          return response.json();
        })
        .then(data => {
          let current_prd_price = $('.product-options .opt-btn:checked+.opt-label').find('.cvp-price').text();
          setCookie('current_prd_price', current_prd_price, 7);
          // if(multplierData){
            let attributesData = {
              'Delivery Address': address,
              '_Delivery Date': del_date_english // Hidden field for integrations (English)
            };
            
            // Add the localized date as a visible attribute
            //attributesData[deliveryDateKey] = del_date;
            // console.log(multplierData)
            // console.log(multplierData !== 'undefined' || multplierData !== null)
            // Agar multplierData defined hai, tabhi extra fields add karo
            if (typeof multplierData !== 'undefined'  && multplierData !== null) {
              console.log(multplierData["% modifier"]);
              console.log(multplierData["% modifier"] * Shopify.currency.rate);
              attributesData['Country Code'] = multplierData["Country code"];
              attributesData['Multiplier Option'] = multplierData["Price modifier option"];
              let multiplier_amount = multplierData["% modifier"] * Shopify.currency.rate;
              attributesData['Multiplier Value'] = parseFloat(multiplier_amount.toFixed(2));;
            }
          
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: {
                attributes: attributesData
              },
              dataType: 'json',
              success: function(cart) {
                console.log('Cart attributes updated:', cart.attributes);
              }
            });
          // }
          const redirectUrl = $button.data('addon');
          if(mainVariantName.includes('Deluxe') == true){
            window.location.href = getCheckoutUrlWithDeliveryCountry(floraqueen.deliveryCountryCode);
          }else{
            if (redirectUrl) {
              if(redirectUrl == '/checkout'){
                window.location.href = getCheckoutUrlWithDeliveryCountry(floraqueen.deliveryCountryCode);
              }else{
                window.location.href = redirectUrl+'&country_code='+floraqueen.deliveryCountryCode;
              }
            }
          }
        })
        .catch(error => {
          console.error('Error adding items to cart:', error);
          if (error.message.includes('is already sold out')){
            $('.pdp-error-modal').addClass('active');
            $('.pdp-error-modal').find('span.pdp-error-highlight').text(window.floraqueen.deliveryCountry);
          } else {
            alert('The product is not available in the selected country of destination.');
          }
        });
      }
    })
    .then(response => {
      if (!response) return; // avoid error if early return
      if (!response.ok) {
        return response.json().then(err => Promise.reject(err));
      }
      return response.json();
    })
    .catch(error => {
      console.error('Error adding items to cart:', error);
      // alert('There was a problem adding products to your cart. Please try again.');
    });
});

// Custom AddToCart handle os starts
$(document).on('click', '[data-add-to-cart-new]', function (e) {
  e.preventDefault();
  const $button = $(this);
  const $form = $button.closest('form');
  const delivery_type_value = $button.data('delivery_type');

  // Step 2: Fetch current cart first
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const itemCount = cart.item_count;

      // If needed, you could display a popup here using cart data
      if (itemCount) {
        let price = getCookie('current_prd_price');
        fetch('/cart/clear.js')
          .then(res => res.json())
          .then(cart => {
            console.log("empty cart", cart);
          })
          .catch(err => console.error(err));
          return;
        return;
      }else{

        const input = document.querySelector("#productPageAddressInput");

        /*if (input && input.value.trim() === "") {
          $('.cdc-title').css('color', '#c64e14');
          setTimeout(function () {
            $('.cdc-title').css('color', '');
          }, 1500);
          input.focus();
          return false; // In a function context
        }

          // Step 1: Ensure a delivery date is selected (skip for wallart products)
        if (!isWallartProduct() && $(document).find('.sdd-item.sdd-active').length === 0) {
          $('.sdd-title').css('color', '#c64e14');
          $('.select-del-date').removeClass('hidden');
          setTimeout(function () {
            $('.sdd-title').css('color', '');
          }, 1500);
          return false;
        }*/

        // Extract the main variant ID from the form
        const mainVariantId = parseInt($form.find('[name="id"] option:selected').val(), 10);
        const cogsProp = $form.find('#cogs-prop').val();
        const mainVariantName = $form.find('[name="id"] option:selected')[0].label;
        if (isNaN(mainVariantId)) {
          console.error('Invalid variant ID');
          return;
        }
        const properties = {'__main_product': 'yes'};
/*
        // Initialize the items array with the main product
        let address = $('#productPageAddressInput').val();
        let del_date = '';
        
        // Only get delivery date if not a wallart product
        if (!isWallartProduct()) {
          let del_date_element = $(document).find('.sdd-item.sdd-active');
          if($(document).find('.del-info-personalize').length){
            del_date = $(document).find('.del-info-personalize').attr('data-value');
          }else{
            if(del_date_element.length && del_date_element.hasClass('sdd-item-3')){
              del_date = del_date_element.find('#del-date').val();
            }else if(del_date_element.length){
              del_date = del_date_element.data('value');
            }
          }
        }
        // console.log(del_date)
        // console.log(cogsProp)
        const currentLocale = Shopify.locale || 'en';
        const translations = {
                              'en': {
                                'Delivery Address': 'Delivery Address',
                                'Delivery Date': 'Delivery Date'
                              },
                              'de': {
                                'Delivery Address': 'Lieferadresse',
                                'Delivery Date': 'Lieferdatum'
                              },
                              'es': {
                                'Delivery Address': 'Delivery Address',
                                'Delivery Date': 'Fecha de entrega'
                              },
                              'fr': {
                                'Delivery Address': 'Adresse de livraison',
                                'Delivery Date': 'Date de livraison'
                              },
                              'it': {
                                'Delivery Address': 'Delivery Address',
                                'Delivery Date': 'Data di consegna'
                              },
                              'pl': {
                                'Delivery Address': 'Delivery Address',
                                'Delivery Date': 'Data dostawy'
                              },
                              'pt-BR': {
                                'Delivery Address': 'Delivery Address',
                                'Delivery Date': 'Data de entrega'
                              },
                              'ru': {
                                'Delivery Address': 'Delivery Address',
                                'Delivery Date': 'Дата доставки'
                              },
                              'tr': {
                                'Delivery Address': 'Delivery Address',
                                'Delivery Date': 'Teslimat tarihi'
                              }
                            };
        
        // Only add delivery date if not a wallart product and date exists
        if (!isWallartProduct() && del_date) {
          properties[translations[currentLocale]['Delivery Date']] = del_date;
        }

        // const properties = {
        //   'Delivery Date': del_date
        // };

        if (cogsProp) {
          properties['_cogs'] = cogsProp;
        }*/

        // Get applied price from variant container
        const mainVariantContainer = document.querySelector(`[data-variant="${mainVariantId}"]`);
        if (mainVariantContainer) {
          /*const appliedPrice = mainVariantContainer.getAttribute('data-applied-price');
          if (appliedPrice) {
            properties['__appliedPrice'] = appliedPrice;
          }*/
        }

        const items = [{
          id: mainVariantId,
          quantity: 1,
          properties: properties
        }];

        const prmVariantIdsToExcludeAddon = [50434772074824, 50434781937992, 50434792325448];
        const dlxVariantIdsToExcludeAddon = [50434772107592, 50434781970760, 50434792358216, 52353219199304, 52364556665160, 50440011972936];
        const prmExcludedVariantIds = [50668515295560]; // Sandy
        const dlxExcludedVariantIds = [50668515295560, 50434757493064]; // Sandy, I Love You

        // Loop through additional selected items
        $('.cpm-item.cpm-active').each(function (index) {
          const variantId = parseInt($(this).data('varid'), 10);
          const isEdAddon = $(this).is('[data-ed-addon]');
          // Express Delivery Card/Vase are explicit customer selections — never auto-exclude
          if (!isEdAddon) {
            if(dlxExcludedVariantIds.indexOf(variantId) !== -1 && dlxVariantIdsToExcludeAddon.indexOf(mainVariantId) !== -1){
              return;
            }
            if(prmExcludedVariantIds.indexOf(variantId) !== -1 && prmVariantIdsToExcludeAddon.indexOf(mainVariantId) !== -1){
              return;
            }
          }
          const cogsProp_1 = $(this).data('cogs');
          const properties_1 = {};

          if (cogsProp_1) {
            properties_1['_cogs'] = cogsProp_1;
          }

          const edAddonType = $(this).attr('data-ed-addon');
          const priceEle = $(this)?.find('.prod-price').attr('data-price');
          if (priceEle && shouldPassAppliedPrice(variantId, edAddonType)) {
            properties_1['__appliedPrice'] = String(priceEle).replace(',', '.');
          }

          // Card design + message on the card line item
          if (edAddonType === 'card') {
            const cardDesign = ($('#ed-card-design').val() || '').trim();
            const cardMessage = ($('#ed-card-text').val() || '').trim();
            if (cardDesign) properties_1['__Card design'] = cardDesign;
            if (cardMessage) properties_1['__Card message'] = cardMessage;
          }

          if (!isNaN(variantId)) {
            items.push({ id: variantId, quantity: 1, properties: properties_1 });
          }
        });

        let i_l_y = $('.cpm-item.ily-add:not(.cpm-active)').data('varid');
        let i_l_y_element = $('.cpm-item.ily-add:not(.cpm-active)');
        let i_l_y_cogs = $('.cpm-item.ily-add:not(.cpm-active)').data('cogs');
        // Express Delivery: do not auto-inject hidden ily-add companions
        if (!isExpressDeliveryPdp($button) && typeof i_l_y !== 'undefined' && i_l_y !== null) {
          let i_l_y_properties = {};

          if (i_l_y_cogs) {
            i_l_y_properties['_cogs'] = i_l_y_cogs;
          }

          // Get applied price from variant container
          const i_l_y_parsed = parseInt(i_l_y, 10);
          if (!isNaN(i_l_y_parsed)) {
            const i_l_y_variantContainer = document.querySelector(`[data-variant="${i_l_y_parsed}"]`);
            if (i_l_y_element?.find('.prod-price').length) {
              const appliedPrice = i_l_y_element?.find('.prod-price').attr('data-price');
              if (appliedPrice) {
                i_l_y_properties['__appliedPrice'] = appliedPrice;
              }
            }
          }

          i_l_y = parseInt(i_l_y, 10);
          if (!isNaN(i_l_y) && dlxVariantIdsToExcludeAddon.indexOf(mainVariantId) !== -1) {
            //items.push({ id: i_l_y, quantity: 1, properties: i_l_y_properties });
          } else{
            items.push({ id: i_l_y, quantity: 1, properties: i_l_y_properties });
          } 
        }

        // Bouquets + Classic/Premium: also add Sandy + I Love You companions
        appendBouquetClassicPremiumCompanions(
          items,
          getAtcProductType($button),
          getSelectedVariantLabel(mainVariantName)
        );

        // Log the payload for debugging
        //console.log('Adding to cart:', JSON.stringify({ items }));

        let multplierData = null;
        if (localStorage.getItem(STORAGE_KEYS.COUNTRY_CODE) !== floraqueen.user_country.country.handle) {
            multplierData = floraqueen.priceModifier.find(
                item => item["Country code"] === floraqueen.user_country.country.handle
            );
        }

        // Step 4: Add to cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        })
        .then(response => {
          if (!response.ok) {
            return response.json().then(err => Promise.reject(err));
          }
          return response.json();
        })
        .then(async data => {
          let current_prd_price = $('.product-options .opt-btn:checked+.opt-label').find('.cvp-price').text();
          setCookie('current_prd_price', current_prd_price, 7);
          console.log('Products added to cart:', data);
          // if(multplierData){
            let attributesData = {
              'preferred_currency': $button.data('currencycode') || $button.attr('data-currencycode'),
              'DomainMargin': window.domainMargin,
              'delivery_type': delivery_type_value ? delivery_type_value : '-'
              //'Delivery Address': address,
              //'Delivery Date': del_date
            };
            // Express Delivery: always set custom_message (value or empty) so back-button
            // cart attributes never leave a stale message at checkout (matches addon-page intent).
            if ($button.data('prod_template') === 'express-delivery') {
              const edCardActive = document.getElementById('ed-ad-card')?.classList.contains('cpm-active');
              const edCardMessage = (document.getElementById('ed-card-text')?.value || '').trim();
              attributesData['custom_message'] = (edCardActive && edCardMessage) ? edCardMessage : '';
            }
            const gclid_data = JSON.parse(localStorage.getItem('gclid_data') || 'null');
            if (gclid_data && Date.now() <= gclid_data.expiry) {
              attributesData['gclid'] = gclid_data.gclid;
              attributesData['utm_campaign'] = gclid_data.utm_campaign;
            }
            
            // _DeliveryCountryCode handling
            // - On .com: force DE ONLY the first time the user is sent to checkout, then never set again.
            // - On other domains: keep previous behavior (use detected delivery country code when available).
            const COM_DELIVERYCODE_ONCE_KEY = 'fq_com__DeliveryCountryCode_once_v1';
            function isComDomain() {
              try {
                const host = (window.location && window.location.hostname) ? window.location.hostname.toLowerCase() : '';
                return host === 'floraqueen.com' || host.endsWith('.floraqueen.com');
              } catch (e) {
                return false;
              }
            }
            function comDeliveryCodeNotUsedYet() {
              if (!isComDomain()) return false;
              try {
                return !window.localStorage.getItem(COM_DELIVERYCODE_ONCE_KEY);
              } catch (e) {
                return false;
              }
            }
            function markComDeliveryCodeUsed() {
              try { window.localStorage.setItem(COM_DELIVERYCODE_ONCE_KEY, '1'); } catch (e) {}
            }
            
            // console.log(multplierData)
            if (typeof multplierData !== 'undefined'  && multplierData !== null) {
              attributesData['Country Code'] = multplierData["Country code"];
              attributesData['Multiplier Option'] = multplierData["Price modifier option"];
              let multiplier_amount = multplierData["% modifier"] * Shopify.currency.rate;
              attributesData['Multiplier Value'] = parseFloat(multiplier_amount.toFixed(2));;
            }

            // Compute redirect destination first, then update cart attributes, then redirect.
            const redirectUrl = $button.data('addon');
            const prodTemplate = $button.data('prod_template');
            const prodId = $button.data('prod_id');
            const prodIdListBasedRedirect = [];
            const marketCode = $button.data('market');

            // Get delivery country code from stored address or localStorage
            let deliveryCountryCode = null;
            if (window.floraqueen && window.floraqueen.deliveryCountryCode) {
              deliveryCountryCode = window.floraqueen.deliveryCountryCode;
            } else if (localStorage.getItem(STORAGE_KEYS.COUNTRY_CODE)) {
              deliveryCountryCode = localStorage.getItem(STORAGE_KEYS.COUNTRY_CODE);
            }

            const partsUrl = redirectUrl.split("/collection");
            let urllgcode = "";
            if (partsUrl[0].length > 1) {
              urllgcode = partsUrl[0];
            }

            function willRedirectToCheckout() {
              if (prodTemplate == 'basket') return true;
              if (prodTemplate == 'express-delivery') return true;
              if (mainVariantName.includes('Deluxe') == true && prodIdListBasedRedirect.includes(prodId) == true) return true;
              if (redirectUrl && redirectUrl == '/checkout') return true;
              return false;
            }

            // Apply _DeliveryCountryCode rules now that we know redirect destination.
            if (isComDomain()) {
              if (comDeliveryCodeNotUsedYet() && willRedirectToCheckout()) {
                attributesData['_DeliveryCountryCode'] = 'DE';
              } else {
                // After the first checkout bootstrap, don't send this attribute anymore.
                delete attributesData['_DeliveryCountryCode'];
              }
            } else {
              // Store delivery country code in cart attributes for checkout pre-selection (non-.com)
              let deliveryCountryCodeForCart = null;
              if (window.floraqueen && window.floraqueen.deliveryCountryCode) {
                deliveryCountryCodeForCart = window.floraqueen.deliveryCountryCode;
              } else if (localStorage.getItem(STORAGE_KEYS.COUNTRY_CODE)) {
                deliveryCountryCodeForCart = localStorage.getItem(STORAGE_KEYS.COUNTRY_CODE);
              }
              if (deliveryCountryCodeForCart) {
                attributesData['_DeliveryCountryCode'] = deliveryCountryCodeForCart;
              }
            }

            function doRedirect() {
              if (prodTemplate == 'basket' || prodTemplate == 'express-delivery') {
                window.location.href = getCheckoutUrlWithDeliveryCountry(deliveryCountryCode);
                return false;
              }

              if (mainVariantName.includes('Deluxe') == true && prodIdListBasedRedirect.includes(prodId) == true) {
                window.location.href = getCheckoutUrlWithDeliveryCountry(deliveryCountryCode);
                return;
              }

              if (mainVariantName.includes('Deluxe') == true) {
                window.location.href = `${urllgcode}/collections/flowers-addons?view=add-on&country_code=${deliveryCountryCode}&continue_skip_1=yes`;
                return;
              }

              if (redirectUrl) {
                if (redirectUrl == '/checkout') {
                  window.location.href = getCheckoutUrlWithDeliveryCountry(deliveryCountryCode);
                } else {
                  const addonCountryCode =
                    deliveryCountryCode ||
                    localStorage.getItem(STORAGE_KEYS.COUNTRY_CODE) ||
                    marketCode;
                  window.location.href = `${urllgcode}/collections/flowers-addons?view=add-on&country_code=${addonCountryCode}`;
                }
              }
            }

            try {
              await new Promise(function (resolve) {
                $.ajax({
                  type: 'POST',
                  url: '/cart/update.js',
                  data: { attributes: attributesData },
                  dataType: 'json',
                  success: function (cart) {
                    //console.log('Cart attributes updated:', cart.attributes);
                  },
                  error: function (xhr) {
                    console.warn('Cart attributes update failed, continuing anyway.', xhr && xhr.status);
                  },
                  complete: function () {
                    resolve();
                  }
                });
              });

              const buyerCountryCode =
                deliveryCountryCode ||
                localStorage.getItem(STORAGE_KEYS.COUNTRY_CODE);
              if (buyerCountryCode) {
                await updateCartBuyerIdentity(buyerCountryCode);
              }
            } catch (error) {
              console.error('Error updating cart before redirect:', error);
            }

            if (isComDomain() && comDeliveryCodeNotUsedYet() && willRedirectToCheckout()) {
              markComDeliveryCodeUsed();
            }
            doRedirect();
        })
        .catch(error => {
          console.error('Error adding items to cart:', error);
          if (error.message.includes('is already sold out')){
            $('.pdp-error-modal').addClass('active');
            $('.pdp-error-modal').find('span.pdp-error-highlight').text(window.floraqueen.deliveryCountry);
          } else {
            alert('The product is not available in the selected country of destination.');
          }
        });
      }
    })
    .then(response => {
      if (!response) return; // avoid error if early return
      if (!response.ok) {
        return response.json().then(err => Promise.reject(err));
      }
      return response.json();
    })
    .catch(error => {
      console.error('Error adding items to cart:', error);
      // alert('There was a problem adding products to your cart. Please try again.');
    });
});
// Custom AddToCart handle os ends

// Update checkout links with delivery country code on page load
// Use setTimeout to ensure DOM is ready and floraqueen object is initialized
setTimeout(function() {
  updateCheckoutLinksWithCountry();
}, 100);  

// CART CLEAR IF A PRODUCT IN CART
$(window).on('load', function(){
   
  // if(window.location.href.includes('view=add-on')){
  //     $('.cpm-item[data-varid="50434757427528"]:not(.cpm-active) .cpm-right').click();
  // }
  // alert()
  if (!window.location.href.includes('view=add-on') && !window.location.href.includes('/account/')) {
     fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const itemCount = cart.item_count;
        if (itemCount) {
          let price = getCookie('current_prd_price');
          fetch('/cart/clear.js')
          .then(res => res.json())
          .then(cart => {
            console.log("empty cart", cart);
          })
          .catch(err => console.error(err));
          return;
        }
      })
      .then(response => {
        if (!response) return;
        if (!response.ok) {
          return response.json().then(err => Promise.reject(err));
        }
        return response.json();
      })
      .catch(error => {
        console.error('Error adding items to cart:', error);
        // alert('There was a problem adding products to your cart. Please try again.');
      });
    }

    if(window.location.href.includes('-addon') && !window.location.href.includes('view=add-on')){
      location.href = '/';
    }
})

// On initial page load, update addon and delivery-date prices for current currency on product pages
document.addEventListener('DOMContentLoaded', function() {
  const isProductPage = document.body.getAttribute('data-page-type') === 'product';
  if (!isProductPage) return;

  // Small delay to ensure DOM and theme scripts have initialized
  setTimeout(function() {
    try {
      updateAddonPrices();
      updateDeliveryDatePrices();
    } catch (e) {
      console.error('Error updating addon/delivery prices on load:', e);
    }
  }, 500);
});

document.addEventListener("DOMContentLoaded", function() {
  // Get the input element
  const addressInput = document.getElementById("productPageAddressInput");

  if (!addressInput) {
    console.log("Address input not found on page");
    return;
  }

  // Function to search and populate city from URL parameter
  async function searchCityFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const cityParam = urlParams.get('city');
    const countryParam = urlParams.get('country');
     if(countryParam){
       const deliveryCountryName = document.querySelector('.delivery-country-name');
       if (deliveryCountryName) {
         deliveryCountryName.textContent = countryParam || '';
       }
       const addressInput = document.getElementById("productPageAddressInput");
       if (addressInput) {
         addressInput.value = null; // Set to null to clear the input
       }
       return;
     }
    // Skip if no city parameter
    if (!cityParam) {
      return;
    }
    
    const cityName = decodeURIComponent(cityParam);
    
    // IMPORTANT: Clear any normal address data first (from manually selected address)
    // This ensures city parameter always takes priority
    addressInput.value = '';
    if (window.floraqueen) {
      window.floraqueen.fullDeliveryAddress = null;
      window.floraqueen.deliveryCountry = null;
      window.floraqueen.deliveryCountryCode = null;
    }
    
    // Always fetch new city from API - don't use saved city data
    // Reset input state
    addressInput.disabled = false;
    addressInput.style.backgroundColor = '';
    addressInput.style.cursor = '';
    
    // Show delete button
    const deleteButton = document.getElementById('delete-location');
    if (deleteButton) {
      deleteButton.style.display = '';
    }

    try {
      // Search for the city using the API
      const data = await window.FQ_GOOGLE.placesAutocomplete({ 
        input: cityName, 
        sessionToken 
      });

      if (data && data.length > 0) {
        // Found results - use the first suggestion
        const firstSuggestion = data[0];
        const addressText = firstSuggestion.description || cityName;
        
        // Set the input value
        addressInput.value = addressText;
        
        // Disable the input
        // addressInput.disabled = true;
        // addressInput.style.backgroundColor = '#f5f5f5';
        // addressInput.style.cursor = 'not-allowed';
        // addressInput.style.display = 'none';
        
        // Hide the delete button since location is locked
        // const deleteButton = document.getElementById('delete-location');
        // if (deleteButton) {
        //   deleteButton.style.display = 'none';
        // }
        
        // Store the full address
        window.floraqueen.fullDeliveryAddress = addressText;
        
        // Resolve components via Google Places API helper
        let parsed = null;
        try {
          if (window.FQ_GOOGLE && typeof window.FQ_GOOGLE.resolveComponents === 'function') {
            parsed = await window.FQ_GOOGLE.resolveComponents({ 
              placeId: firstSuggestion.place_id, 
              address: addressText 
            });
          }
        } catch (error) {
          console.warn("Error resolving components:", error);
        }

        // Strong fallback if helper not available
        if (!parsed || (!parsed.countryCode && !parsed.countryName)) {
          const fallbackCountry = extractCountryFromAddress(addressText);
          const fallbackCode = fallbackCountry ? getCountryCode(fallbackCountry) : null;
          parsed = parsed || {};
          parsed.countryName = parsed.countryName || fallbackCountry || null;
          parsed.countryCode = parsed.countryCode || fallbackCode || null;
        }

        if (parsed && parsed.countryName) {
          window.floraqueen.deliveryCountry = parsed.countryName;
        }

        if (parsed && parsed.countryCode) {
          const previousCountryCode = window.floraqueen.deliveryCountryCode;
          const hasCountryChanged = previousCountryCode !== parsed.countryCode;

          window.floraqueen.deliveryCountryCode = parsed.countryCode;
          evaluateCountryShipping(parsed.countryName, parsed.countryCode);

          // Save to city-based localStorage (not normal address storage)
          console.log("---parsed", parsed, 'addressText', addressText);
          saveCityAddressData(addressText, parsed.countryName, parsed.countryCode);

          console.log("City from URL found and populated:", {
            city: cityName,
            address: addressText,
            country: parsed.countryName,
            countryCode: parsed.countryCode,
            previousCode: previousCountryCode,
            changed: hasCountryChanged
          });

          if (hasCountryChanged) {
            handleMarketChange(parsed.countryCode);
          }
          // Update checkout links with new delivery country code
          setTimeout(function() {
            updateCheckoutLinksWithCountry();
          }, 100);
        } else {
          console.warn("Could not resolve country code for:", addressText);
        }

        // Update delivery-city-name element with city and country
        if (parsed) {
          const deliveryCityName = document.querySelector('.delivery-city-name');
          if (deliveryCityName) {
            const city = parsed.city || cityName;
            const country = parsed.countryName || '';
            if (city && country) {
              deliveryCityName.textContent = `${city}, ${country}`;
            } else if (city) {
              deliveryCityName.textContent = city;
            }
          }
        }

        // Generate new session token after selection
        sessionToken = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
          const r = (Math.random() * 16) | 0,
                v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        });
      } else {
        // No results found - keep input enabled
        console.log("City from URL not found in API:", cityName);
      }
    } catch (error) {
      console.error("Error searching city from URL:", error);
      // On error, keep input enabled
    }
  }

  // Create a container for displaying suggestions
  const suggestionsContainer = document.createElement("div");
  suggestionsContainer.className = "address-suggestions";
  suggestionsContainer.style.display = "none";
  suggestionsContainer.style.position = "absolute";
  suggestionsContainer.style.width = "100%";
  suggestionsContainer.style.backgroundColor = "white";
  suggestionsContainer.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
  suggestionsContainer.style.zIndex = "1000";
  suggestionsContainer.style.borderRadius = "4px";
  suggestionsContainer.style.marginTop = "4px";

  // Insert suggestions container after the input container
  addressInput.parentNode.parentNode.insertBefore(suggestionsContainer, addressInput.parentNode.nextSibling);

  // Generate a session token (UUID v4-like)
  let sessionToken = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

  // Debounce function to prevent too many API calls
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  // Function to extract country from address
  function extractCountryFromAddress(address) {
    if (!address) return null;

    // Split the address by commas and get the last part which is likely the country
    const parts = address.split(',');
    if (parts.length > 0) {
      // Get the last part and trim whitespace
      const country = parts[parts.length - 1].trim();
      return country;
    }

    return null;
  }

  // Function to get ISO country code from country name
  function getCountryCode(countryName) {
    if (!window.floraqueen.countryCodes || !countryName) return null;
      if (countryName.toLowerCase() === 'türkiye') {
        countryName = 'Turkey';
      }
      // First try exact match
      const exactMatch = window.floraqueen.countryCodes.find(
        item => item["Country Name"].toLowerCase() === countryName.toLowerCase()
      );

      if (exactMatch) return exactMatch["Country Code"];
      // Try to find a country that includes the countryName (for partial matches)
      const partialMatch = window.floraqueen.countryCodes.find(
        item => item["Country Name"].toLowerCase().includes(countryName.toLowerCase()) ||
              countryName.toLowerCase().includes(item["Country Name"].toLowerCase())
      );

      if (partialMatch) return partialMatch["Country Code"];

      return null;
}

  // Function to save delivery address data to localStorage (normal address)
  function saveDeliveryAddressData(fullAddress, country, countryCode) {
    if (fullAddress) localStorage.setItem(STORAGE_KEYS.FULL_ADDRESS, fullAddress);
    if (country) localStorage.setItem(STORAGE_KEYS.COUNTRY, country);
    if (countryCode) localStorage.setItem(STORAGE_KEYS.COUNTRY_CODE, countryCode);
  }

  // Function to save city-based address data to localStorage (from URL parameter)
  function saveCityAddressData(fullAddress, country, countryCode) {
    if (fullAddress) localStorage.setItem(STORAGE_KEYS.CITY_FULL_ADDRESS, fullAddress);
    if (country) localStorage.setItem(STORAGE_KEYS.CITY_COUNTRY, country);
    if (countryCode) localStorage.setItem(STORAGE_KEYS.CITY_COUNTRY_CODE, countryCode);
  }

  // Function to load city-based address data from localStorage
  function loadCityAddressData() {
    const fullAddress = localStorage.getItem(STORAGE_KEYS.CITY_FULL_ADDRESS);
    const country = localStorage.getItem(STORAGE_KEYS.CITY_COUNTRY);
    const countryCode = localStorage.getItem(STORAGE_KEYS.CITY_COUNTRY_CODE);

    if (fullAddress) window.floraqueen.fullDeliveryAddress = fullAddress;
    if (country) window.floraqueen.deliveryCountry = country;
    if (countryCode) window.floraqueen.deliveryCountryCode = countryCode;

    return { fullAddress, country, countryCode };
  }

  // Function to clear city-based address data
  function clearCityAddressData() {
    localStorage.removeItem(STORAGE_KEYS.CITY_FULL_ADDRESS);
    localStorage.removeItem(STORAGE_KEYS.CITY_COUNTRY);
    localStorage.removeItem(STORAGE_KEYS.CITY_COUNTRY_CODE);
  }

  // Function to fetch address suggestions
  async function fetchAddressSuggestions(input) {
    if (input.length < 3) {
      suggestionsContainer.style.display = "none";
      return;
    }
    // let locale_lang = Shopify.locale ? Shopify.locale : "en";

    try {
      const data = await window.FQ_GOOGLE.placesAutocomplete({ input, sessionToken });

      // Clear previous suggestions
      suggestionsContainer.innerHTML = "";

      // Display the suggestions
      if (data && data.length > 0) {
        suggestionsContainer.style.display = "block";

        data.forEach((suggestion) => {
          const text = suggestion.description || "Unknown";

          const suggestionItem = document.createElement("div");
          suggestionItem.className = "suggestion-item";
          suggestionItem.textContent = text;
          suggestionItem.style.padding = "10px 15px";
          suggestionItem.style.cursor = "pointer";
          suggestionItem.style.borderBottom = "1px solid #f0f0f0";

          suggestionItem.addEventListener("mouseenter", function() {
            this.style.backgroundColor = "#f9f9f9";
          });

          suggestionItem.addEventListener("mouseleave", function() {
            this.style.backgroundColor = "transparent";
          });

          suggestionItem.addEventListener("click", async function() {
            addressInput.value = text;
            suggestionsContainer.style.display = "none";

            // Store the full address
            window.floraqueen.fullDeliveryAddress = text;
            
            // Resolve components via Google Places API helper
            let parsed = null;
            try {
              if (window.FQ_GOOGLE && typeof window.FQ_GOOGLE.resolveComponents === 'function') {
                parsed = await window.FQ_GOOGLE.resolveComponents({ placeId: suggestion.place_id, address: text });
              }
            } catch (error) {
              console.warn("Error resolving components:", error);
            }

            // Strong fallback if helper not available
            if (!parsed || (!parsed.countryCode && !parsed.countryName)) {
              const fallbackCountry = extractCountryFromAddress(text);
              const fallbackCode = fallbackCountry ? getCountryCode(fallbackCountry) : null;
              parsed = parsed || {};
              parsed.countryName = parsed.countryName || fallbackCountry || null;
              parsed.countryCode = parsed.countryCode || fallbackCode || null;
            }

            if (parsed && parsed.countryName) {
              window.floraqueen.deliveryCountry = parsed.countryName;
            }

            if (parsed && parsed.countryCode) {
              const previousCountryCode = window.floraqueen.deliveryCountryCode;
              const hasCountryChanged = previousCountryCode !== parsed.countryCode;

              window.floraqueen.deliveryCountryCode = parsed.countryCode;
              evaluateCountryShipping(parsed.countryName, parsed.countryCode);

              // Save to localStorage
              saveDeliveryAddressData(text, parsed.countryName, parsed.countryCode);

              console.log("Delivery details updated:", {
                country: parsed.countryName,
                countryCode: parsed.countryCode,
                previousCode: previousCountryCode,
                changed: hasCountryChanged
              });

              if (hasCountryChanged) {
                handleMarketChange(parsed.countryCode);
              }
              // Update checkout links with new delivery country code
              setTimeout(function() {
                updateCheckoutLinksWithCountry();
              }, 100);
            } else {
              console.warn("Could not resolve country code for:", text);
            }

            // Generate new session token after selection
            sessionToken = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
              const r = (Math.random() * 16) | 0,
                    v = c == "x" ? r : (r & 0x3) | 0x8;
              return v.toString(16);
            });
          });

          suggestionsContainer.appendChild(suggestionItem);
        });
      } else {
        suggestionsContainer.style.display = "none";
      }
    } catch (error) {
      console.error("Error fetching address suggestions:", error);
      suggestionsContainer.style.display = "none";
    }
  }

  // Add input event listener with debounce
  addressInput.addEventListener("input", debounce(function(e) {
    const value = e.target.value.trim();
    fetchAddressSuggestions(value);
  }, 300)); // 300ms debounce

  // Hide suggestions when clicking outside
  document.addEventListener("click", function(e) {
    if (e.target !== addressInput && !suggestionsContainer.contains(e.target)) {
      suggestionsContainer.style.display = "none";
    }
  });

  // Check for city parameter in URL first
  const urlParamsCheck = new URLSearchParams(window.location.search);
  const cityParamCheck = urlParamsCheck.get('city');
  const countryParamCheck = urlParamsCheck.get('country');
  
  if (cityParamCheck) {
    // Scenario 1: URL contains city parameter - use city-based storage
    // IMPORTANT: Clear any normal address data that might have been loaded
    // This ensures city parameter always takes priority over manually selected address
    addressInput.value = '';
    if (window.floraqueen) {
      window.floraqueen.fullDeliveryAddress = null;
      window.floraqueen.deliveryCountry = null;
      window.floraqueen.deliveryCountryCode = null;
    }
    
    // When city parameter exists: show city section and normal section; hide country-only section
    const defaultCity = document.querySelector('.cdc-default-city');
    const defaultCountry = document.querySelector('.cdc-default-country');
    const defaultNormal = document.querySelector('.cdc-default-normal');
    console.log('----------------------------------------------------------------------');
    if (defaultCity) {
      defaultCity.style.display = 'none';
      defaultCountry.style.display = 'none';
      if (defaultNormal) defaultNormal.style.display = 'block';
    }
    
    // Wait a bit to ensure FQ_GOOGLE is available
    setTimeout(() => {
      if (window.FQ_GOOGLE && typeof window.FQ_GOOGLE.placesAutocomplete === 'function') {
        searchCityFromUrl();
      } else {
        // If FQ_GOOGLE not ready yet, wait a bit more
        setTimeout(() => {
          if (window.FQ_GOOGLE && typeof window.FQ_GOOGLE.placesAutocomplete === 'function') {
            searchCityFromUrl();
          }
        }, 500);
      }
    }, 100);
  } else if(countryParamCheck){
    // Scenario 2: URL contains country parameter - use country-based storage
    const defaultCity = document.querySelector('.cdc-default-city');
    const defaultCountry = document.querySelector('.cdc-default-country');
    const defaultNormal = document.querySelector('.cdc-default-normal');
    if (defaultCity) {
      defaultCity.style.display = 'none';
      defaultCountry.style.display = 'block';
      defaultNormal.style.display = 'block';
    }
    // Clear input and floraqueen data
    addressInput.value = '';
    if (window.floraqueen) {
      window.floraqueen.fullDeliveryAddress = null;
      window.floraqueen.deliveryCountry = null;
      window.floraqueen.deliveryCountryCode = null;
    }
    // Update delivery country name from URL parameter
    const deliveryCountryName = document.querySelector('.delivery-country-name');
    if (deliveryCountryName) {
      deliveryCountryName.textContent = countryParamCheck || '';
    }
    // Don't call searchCityFromUrl() when country parameter exists - just show country
  } else{
    const defaultNormal = document.querySelector('.cdc-default-normal');
    if (defaultNormal) {
      defaultNormal.style.display = 'block';
    }
    // Scenario 2: No URL parameter - use normal saved address logic
    loadSavedAddressData();
  }

  // $( "#del-date" ).datepicker({
  //     dateFormat: "dd-mm-yy",
  //     duration: "fast",
  //     numberOfMonths:2,
  //     appendTo: "body",
  //     beforeShow: function(input, inst) {
  //       setTimeout(function() {
  //         inst.dpDiv.css({
  //           top: "90vh",
  //           left: "41.5vw",
  //           right: "auto",
  //           zIndex: 9999
  //         });
  //       }, 0);
  //     }
  // });

  $(function () {
    console.log("datepicker 2");
    var $input = $('#del-date');
    if (!$input.length || typeof $.fn.datepicker !== 'function') {
      return;
    }
    var $datepicker = null;

    // Check if input has both id="del-date" and class="basket-template-datepicker"
    var isBasketTemplate = $input.attr('id') === 'del-date' && $input.hasClass('basket-template-datepicker');
    var minDateValue;
    if (isBasketTemplate && typeof isBasketSantJordiProduct === 'function' && isBasketSantJordiProduct()) {
      minDateValue = typeof getSantJordiBasketChooseMinDate === 'function'
        ? getSantJordiBasketChooseMinDate()
        : new Date((typeof getSantJordiCampaignYear === 'function' ? getSantJordiCampaignYear() : new Date().getFullYear()), 3, 17);
    } else {
      minDateValue = isBasketTemplate ? 6 : 0;
    }

    // Show 1 month on mobile, 2 months on desktop
    var isMobileDevice = window.innerWidth <= 767;
    var numberOfMonths = isMobileDevice ? 1 : 2;

    $input.datepicker({
      numberOfMonths: numberOfMonths,
      dateFormat: "dd MM yy",
      minDate: minDateValue,
      appendTo: "body",
      beforeShowDay: function(date) {
        return delDateBeforeShowDay(date, isBasketTemplate);
      },
      onSelect: function(dateText) {
        $(".main-product-cont[data-template='custom1'] .sdd-item-3 .sdd-day").text(dateText);
        $(".main-product-cont[data-template='custom1'] .sdd-item-3 .sdd-date").text('CHANGE');

        $(".main-product-cont[data-template='custom2'] .sdd-item-3 .sdd-price").text('CHANGE');
        $(".sdd-outer-item-3 .sdd-delivery-date").text(dateText);
      },
      beforeShow: function (input, inst) {
        setTimeout(function () {
          $datepicker = inst.dpDiv;
          // Small delay to ensure datepicker is fully rendered
          setTimeout(function() {
            positionDatepicker($input, $datepicker);
          }, 10);
        }, 0);
      }
    });


    // Reposition on scroll and resize
    $(window).on('scroll resize', function () {
      if ($datepicker && $datepicker.is(':visible')) {
        positionDatepicker($input, $datepicker);
      }
    });

    function positionDatepicker($input, $picker) {
      var inputOffset = $input.offset();
      var inputHeight = $input.outerHeight();
      var inputWidth = $input.outerWidth();
      var pickerHeight = $picker.outerHeight();

      var pickerWidth = $picker.outerWidth();
      
      // Check if mobile device (screen width <= 767px)
      var isMobile = window.innerWidth <= 767;
      var scrollTop = $(window).scrollTop();
      var sddItem3Offset = $(".sdd-item-3").offset();
      
      var windowHeight = $(window).height();
      
      if (isMobile) {
        // Center the datepicker on mobile - position it in the center of the viewport
        var topPosition = Math.max(10, (windowHeight - pickerHeight) / 2);
        
        $picker.css({
          position: 'fixed',
          top: topPosition + 'px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 99999,
          margin: '0 auto'
        });
      } else {
        // Desktop positioning (original behavior - unchanged)
        $picker.css({
          position: 'absolute',
          top: inputOffset.top + (inputHeight / 2) - (pickerHeight / 2),
          left: sddItem3Offset ? (sddItem3Offset.left - pickerWidth - 10) : (inputOffset.left - pickerWidth - 10),
          zIndex: 9999,
          transform: 'none',
          margin: '0'
        });
      }
    }
  });

});

// Currency Selector Change Handler - Extract country code and update cart attributes
(function() {
  'use strict';
  
  // Mapping function to convert country names from Doubly selector to ISO country codes
  function getCountryCodeFromName(countryName) {
    if (!countryName) return null;
    
    // Normalize the country name (remove hyphens, convert to lowercase)
    const normalized = countryName.toLowerCase().replace(/-/g, ' ').trim();
    
    // Country name to ISO code mapping (based on Doubly's data-country values)
    const countryNameToCode = {
      'united states': 'US',
      'united kingdom': 'GB',
      'canada': 'CA',
      'australia': 'AU',
      'brazil': 'BR',
      'china': 'CN',
      'israel': 'IL',
      'japan': 'JP',
      'poland': 'PL',
      'romania': 'RO',
      'russia': 'RU',
      'switzerland': 'CH',
      'turkey': 'TR',
      'türkiye': 'TR',
      'european union': 'EU',
      'europe': 'EU'
    };
    
    // Direct lookup
    if (countryNameToCode[normalized]) {
      return countryNameToCode[normalized];
    }
    
    // Try partial matching for variations
    for (const [key, code] of Object.entries(countryNameToCode)) {
      if (normalized.includes(key) || key.includes(normalized)) {
        return code;
      }
    }
    
    console.warn('Could not map country name to code:', countryName);
    return null;
  }
  
  // Function to extract country code from flag class (e.g., "flags-Canada" -> "CA")
  function getCountryCodeFromFlagClass() {
    const flagElement = document.querySelector('.doubly-nice-select .flags, .doubly-nice-select .current .flags');
    if (flagElement) {
      const flagClasses = Array.from(flagElement.classList);
      const flagClass = flagClasses.find(cls => cls.startsWith('flags-'));
      if (flagClass) {
        const countryFromFlag = flagClass.replace('flags-', '');
        return getCountryCodeFromName(countryFromFlag);
      }
    }
    return null;
  }
  
  // Function to update cart attributes with country code and currency code
  function updateCartAttributesWithCountryCode(countryCode, currencyCode) {
    if (!countryCode && !currencyCode) {
      console.warn('No country code or currency code provided to update cart attributes');
      return;
    }
    
    // Fetch current cart to preserve existing attributes
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const existingAttributes = cart.attributes || {};
        
        // Create updated attributes object
        const updatedAttributes = {
          ...existingAttributes
        };
        
        // Add country code if provided
        if (countryCode) {
          updatedAttributes['preferred_country'] = countryCode;
        }
        
        // Add currency code if provided
        if (currencyCode) {
          updatedAttributes['preferred_currency'] = currencyCode;
        }
        
        // Update cart attributes
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            attributes: updatedAttributes
          })
        });
      })
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}: ${res.statusText}`);
        }
        return res.json();
      })
      .then(cart => {
        if (countryCode) {
          console.log('Cart attributes updated with preferred_country:', countryCode);
        }
        if (currencyCode) {
          console.log('Cart attributes updated with preferred_currency:', currencyCode);
        }
        console.log('Updated cart attributes:', cart.attributes);
      })
      .catch(error => {
        console.error('Error updating cart attributes:', error);
      });
  }
  
  // Function to extract currency code from current selection (e.g., "USD", "CAD", "GBP")
  function getCurrentCurrencyCode() {
    const currencySelect = document.querySelector('select[name="doubly-currencies"]');
    if (currencySelect) {
      const selectedOption = currencySelect.options[currencySelect.selectedIndex];
      if (selectedOption) {
        // Currency code is in the value attribute
        const currencyCode = selectedOption.value || selectedOption.getAttribute('data-display');
        if (currencyCode) return currencyCode;
      }
    }
    return null;
  }
  
  // Function to extract country code from current selection
  function getCurrentCountryCode() {
    // Method 1: Try to get from select element's selected option
    const currencySelect = document.querySelector('select[name="doubly-currencies"]');
    if (currencySelect) {
      const selectedOption = currencySelect.options[currencySelect.selectedIndex];
      if (selectedOption) {
        const countryName = selectedOption.getAttribute('data-country');
        if (countryName) {
          const countryCode = getCountryCodeFromName(countryName);
          if (countryCode) return countryCode;
        }
      }
    }
    
    // Method 2: Try to get from flag class
    const countryCodeFromFlag = getCountryCodeFromFlagClass();
    if (countryCodeFromFlag) return countryCodeFromFlag;
    
    return null;
  }
  
  // Function to handle currency selector change
  function handleCurrencySelectorChange() {
    // Method 1: Listen to the select element change
    const currencySelect = document.querySelector('select[name="doubly-currencies"]');
    if (currencySelect) {
      currencySelect.addEventListener('change', function() {
        const selectedOption = this.options[this.selectedIndex];
        const countryName = selectedOption ? selectedOption.getAttribute('data-country') : null;
        const currencyCode = selectedOption ? (selectedOption.value || selectedOption.getAttribute('data-display')) : null;
        
        let countryCode = null;
        if (countryName) {
          countryCode = getCountryCodeFromName(countryName);
        } else {
          // Fallback to flag class
          countryCode = getCountryCodeFromFlagClass();
        }
        
        if (countryCode || currencyCode) {
          console.log('Currency changed (from select) - Country:', countryName, 'Country Code:', countryCode, 'Currency Code:', currencyCode);
          updateCartAttributesWithCountryCode(countryCode, currencyCode);
        }
      });
    }
    
    // Method 2: Listen to mutations on the display element (for when Doubly updates it)
    const currencyDisplay = document.querySelector('.doubly-nice-select.currency-switcher');
    if (currencyDisplay) {
      // Watch for changes in the flag class or text content
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' || mutation.type === 'childList') {
            // Small delay to ensure DOM is updated
            setTimeout(function() {
              const countryCode = getCurrentCountryCode();
              const currencyCode = getCurrentCurrencyCode();
              if (countryCode || currencyCode) {
                console.log('Currency changed (from mutation) - Country Code:', countryCode, 'Currency Code:', currencyCode);
                updateCartAttributesWithCountryCode(countryCode, currencyCode);
              }
            }, 50);
          }
        });
      });
      
      // Start observing
      observer.observe(currencyDisplay, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class']
      });
    }
    
    // Method 3: Also listen for clicks on the nice-select dropdown (if it's a custom dropdown)
    document.addEventListener('click', function(e) {
      const clickedOption = e.target.closest('.doubly-nice-select .option, .doubly-nice-select li, .doubly-nice-select .current');
      if (clickedOption && clickedOption.closest('.doubly-nice-select')) {
        // Small delay to allow Doubly to update the select element
        setTimeout(function() {
          const countryCode = getCurrentCountryCode();
          const currencyCode = getCurrentCurrencyCode();
          if (countryCode || currencyCode) {
            console.log('Currency changed (from click) - Country Code:', countryCode, 'Currency Code:', currencyCode);
            updateCartAttributesWithCountryCode(countryCode, currencyCode);
          }
        }, 150);
      }
    });
    
    // Method 4: Set initial country code and currency code on page load
    setTimeout(function() {
      const countryCode = getCurrentCountryCode();
      const currencyCode = getCurrentCurrencyCode();
      if (countryCode || currencyCode) {
        console.log('Initial currency detected - Country Code:', countryCode, 'Currency Code:', currencyCode);
        updateCartAttributesWithCountryCode(countryCode, currencyCode);
      }
    }, 500);
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleCurrencySelectorChange);
  } else {
    // DOM already loaded
    handleCurrencySelectorChange();
  }
  
  // Also try after a delay to catch late-loading elements
  setTimeout(handleCurrencySelectorChange, 1000);
  setTimeout(handleCurrencySelectorChange, 2000);
})();
/*-------------------------------- Mobile dropdown scroll fix: Enable scrolling by setting proper height and overflow --------------------------------*/
// Mobile dropdown scroll fix: Enable scrolling by setting proper height and overflow
$(document).ready(function() {
  // Make Destinations label open the same dropdown as the arrow on mobile
  $(document).on('click', '.mobile-nav-column-inner .main-nav__item > .main-nav__link', function(e) {
    if (!window.matchMedia('(max-width: 1023px)').matches) {
      return;
    }

    if (!$('body').hasClass('mobile-menu-open')) {
      return;
    }

    var $link = $(this);
    var $item = $link.closest('.main-nav__item');
    var title = ($item.data('title') || '').toString().toLowerCase();
    var isDestinations = $item.data('index') == 8 || [
      'destinations',
      'destinos',
      'teslimat noktaları',
      'направления',
      'versandregionen',
      'destinazioni',
      'miejsca docelowe'
    ].indexOf(title) !== -1;

    if (!isDestinations) {
      return;
    }

    var $trigger = $item.children('.js-mobile-dropdown-trigger');
    if ($trigger.length) {
      e.preventDefault();
      $trigger.first().trigger('click');
    }
  });

  // Handle click on mobile dropdown trigger
  $(document).on('click', '.js-mobile-dropdown-trigger', function(e) {
    var $trigger = $(this);
    var $originalDropdown = $trigger.siblings('.main-nav__dropdown, .main-nav__sub-dropdown');
    
    if ($originalDropdown.length) {
      // Get the height of the original dropdown content (scrollHeight includes all content)
      var dropdownContentHeight = $originalDropdown[0].scrollHeight || $originalDropdown.outerHeight();
      
      // Wait for the dropdown to be cloned and added to DOM (theme.js uses setTimeout with 10ms)
      setTimeout(function() {
        // Find the most recently added mobile dropdown container
        var $mobileDropdownContainer = $('.mobile-nav-column-inner');
        var $mobileDropdown = $mobileDropdownContainer.find('.mobile-dropdown.mobile-menu-level-2, .mobile-dropdown.mobile-menu-level-3').last();
        
        if ($mobileDropdown.length) {
          // Get the back button height
          var $backButton = $mobileDropdown.find('.mobile-dropdown__back');
          var backButtonHeight = $backButton.length ? $backButton.outerHeight() : 0;
          
          // Calculate available viewport height (accounting for header and back button)
          var viewportHeight = $(window).height();
          var availableHeight = viewportHeight - backButtonHeight - 50; // Add 50px more scroll
          
          // Set height and enable scrolling on the mobile dropdown container
          $mobileDropdown.css({
            'height': availableHeight + 'px',
            'max-height': availableHeight + 'px',
            'overflow-y': 'auto',
            'overflow-x': 'hidden',
            '-webkit-overflow-scrolling': 'touch'
          });
          
          // Ensure the dropdown list inside can scroll
          var $dropdownList = $mobileDropdown.find('.main-nav__dropdown, .main-nav__sub-dropdown').first();
          if ($dropdownList.length) {
            $dropdownList.css({
              'overflow-y': 'visible',
              'height': 'auto'
            });
          }
          
          console.log('Applied scroll settings - Container height:', availableHeight + 'px', 'Content height:', dropdownContentHeight + 'px');
        }
      }, 100); // Wait a bit longer to ensure DOM is updated
    }
  });
  
  // Fix scrolling for main mobile menu when hamburger icon is clicked
  $(document).on('click', '.js-mobile-menu-icon', function(e) {
    // Wait for menu to open (theme.js uses setTimeout with 10ms)
    setTimeout(function() {
      var $menuContainer = $('.mobile-nav-menu-container');
      
      if ($menuContainer.length && $('body').hasClass('mobile-menu-open')) {
        // Get viewport height
        var viewportHeight = $(window).height();
        
        // Get header/logo height if present
        var $header = $menuContainer.find('.header-group, .mobile-nav-column-inner > *:first-child');
        var headerHeight = $header.length ? $header.outerHeight() : 0;
        
        // Calculate available height (subtract 50px as per user preference)
        var availableHeight = viewportHeight - headerHeight - 50;
        
        // Set height and enable scrolling on the main menu container
        $menuContainer.css({
          'height': availableHeight + 'px',
          'max-height': availableHeight + 'px',
          'overflow-y': 'auto',
          'overflow-x': 'hidden',
          '-webkit-overflow-scrolling': 'touch'
        });
        
        console.log('Applied scroll settings to main menu - Container height:', availableHeight + 'px');
      }
    }, 100);
  });
  
  // Also handle when menu opens via class change (MutationObserver or event)
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if ($('body').hasClass('mobile-menu-open')) {
          setTimeout(function() {
            var $menuContainer = $('.mobile-nav-menu-container');
            
            if ($menuContainer.length) {
              var viewportHeight = $(window).height();
              var $header = $menuContainer.find('.header-group, .mobile-nav-column-inner > *:first-child');
              var headerHeight = $header.length ? $header.outerHeight() : 0;
              var availableHeight = viewportHeight - headerHeight - 50;
              
              $menuContainer.css({
                'height': availableHeight + 'px',
                'max-height': availableHeight + 'px',
                'overflow-y': 'auto',
                'overflow-x': 'hidden',
                '-webkit-overflow-scrolling': 'touch'
              });
            }
          }, 100);
        }
      }
    });
  });
  
  // Observe body class changes
  // if ($('body').length) {
  //   observer.observe($('body')[0], {
  //     attributes: true,
  //     attributeFilter: ['class']
  //   });
  // }
});
/*-------------------------------- EOF Mobile dropdown scroll fix: Enable scrolling by setting proper height and overflow --------------------------------*/

/*-------------------------------- Mobile header search toggle --------------------------------*/
$(function () {
  function closeMobileHeaderSearch() {
    $('body').removeClass('mobile-header-search-open');
  }

  function openMobileHeaderSearch() {
    $('body').addClass('mobile-header-search-open');
    // focus after animation starts
    setTimeout(function () {
      var $input = $('[data-mobile-header-search] .mobile-header-search__input').first();
      if ($input.length) $input.trigger('focus');
    }, 80);
  }

  $(document).on('click', '.js-mobile-header-search-toggle', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if ($('body').hasClass('mobile-header-search-open')) {
      closeMobileHeaderSearch();
    } else {
      openMobileHeaderSearch();
    }
  });

  $(document).on('click', '[data-mobile-header-search-backdrop]', function () {
    closeMobileHeaderSearch();
  });

  // Close when clicking outside panel
  $(document).on('click', function (e) {
    if (!$('body').hasClass('mobile-header-search-open')) return;
    var $panel = $('[data-mobile-header-search] .mobile-header-search__panel');
    var $toggle = $('.js-mobile-header-search-toggle');
    var target = e.target;
    if ($panel.length && $panel[0].contains(target)) return;
    if ($toggle.length && $toggle[0].contains(target)) return;
    closeMobileHeaderSearch();
  });

  // Esc to close
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $('body').hasClass('mobile-header-search-open')) {
      closeMobileHeaderSearch();
    }
  });

  // If mobile menu opens, close search to avoid overlaps
  $(document).on('click', '.js-mobile-menu-icon', function () {
    closeMobileHeaderSearch();
  });
});
/*-------------------------------- EOF Mobile header search toggle --------------------------------*/